import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

const resources = {
  en: {
    translation: {
      sidebar: {
        scene: 'Scene',
        device: 'Device',
        export: 'Export',
      },
      tagAutocomplete: {
        create: 'Create "{{value}}"',
        empty: 'No matching tags',
      },
      scene: {
        select: {
          title: 'Scene Preset',
        },
        background: {
          title: 'Background',
          gradient: 'Gradient',
          image: 'Image',
          color: 'Color',
          opacity: 'Opacity',
          position: 'Position',
          angle: 'Angle',
          upload: 'Upload Image',
          uploading: 'Uploading…',
          dropHere: 'Drop image here',
          fitMode: 'Fit Mode',
          fill: 'Fill',
          contain: 'Contain',
          cover: 'Cover',
          offset: 'Offset',
          zoom: 'Zoom',
          change: 'Browse Presets',
          presets: 'Background Presets',
          noPresets: 'No preset backgrounds available.',
          invalidType: 'Only JPEG, PNG, and WebP images are supported.',
          tooLarge: 'Image must be smaller than 5 MB.',
          uploadError: "Oops, couldn't upload the image. Please try again.",
        },
        lighting: {
          title: 'Lighting & Shadows',
          lights: 'Lights',
          addLight: 'Add Light',
          removeLight: 'Remove',
          lightLabel: 'Light',
          color: 'Color',
          intensity: 'Intensity',
          direction: 'Direction',
          height: 'Height',
          shadowIntensity: 'Shadow',
          shadowSoftness: 'Softness',
          ambient: 'Ambient Light',
          ambientColor: 'Color',
          ambientIntensity: 'Intensity',
          envMap: 'Environment Map',
          envMapChange: 'Change',
          envMapIntensity: 'Intensity',
          groundDistance: 'Ground Distance',
        },
        camera: {
          presets: 'Camera Presets',
          preset_front: 'Front',
          preset_topRight: 'Top Right',
          preset_topLeft: 'Top Left',
          preset_frontDetail: 'Detail',
        },
      },
      device: {
        select: {
          title: 'Device',
          custom: 'Custom Device',
          loading: 'Loading devices…',
          error: 'Failed to load devices',
        },
        rotation: {
          title: 'Rotation',
        },
        depth: {
          title: 'Depth',
        },
        shapes: {
          title: 'Dimensions',
          width: 'Width',
          height: 'Height',
          depth: 'Depth',
          cornerRadius: 'Corner Radius',
          edgeBevel: 'Edge Bevel',
          unit: 'mm',
        },
        frontFace: {
          title: 'Front Face',
          inset: 'Front Face Inset',
          displayCornerRadius: 'Display Corner Radius',
          displayInsetX: 'Display Inset X',
          displayInsetY: 'Display Inset Y',
          displayReflection: 'Display Reflection',
          homeButton: 'Home Button',
          homeButtonX: 'Position X',
          homeButtonY: 'Position Y',
          homeButtonRadius: 'Radius',
          cameraLens: 'Camera Lens',
          cameraLensRadius: 'Radius',
          displayCutout: 'Display Cutout',
          displayCutoutWidth: 'Width',
          displayCutoutHeight: 'Height',
          displayCutoutY: 'Position Y',
          homeIndicator: 'Home Indicator',
          homeIndicatorWidth: 'Width',
          homeIndicatorHeight: 'Height',
          homeIndicatorY: 'Position Y',
          homeIndicatorDark: 'Dark',
          frontSpeaker: 'Front Speaker',
          frontSpeakerWidth: 'Width',
          frontSpeakerHeight: 'Height',
          addFeature: 'Add Feature',
          featureTypes: {
            homeButton: 'Home Button',
            cameraLens: 'Camera Lens',
            displayCutout: 'Display Cutout',
            homeIndicator: 'Home Indicator',
            frontSpeaker: 'Front Speaker',
            customDecal: 'Custom Decal',
          },
        },
        sideEdges: {
          title: 'Side Edges',
          edges: {
            left: 'Left Edge',
            right: 'Right Edge',
            top: 'Top Edge',
            bottom: 'Bottom Edge',
          },
          addFeature: 'Add Feature',
          featureTypes: {
            sideButton: 'Side Button',
            muteSwitch: 'Mute Switch',
            antenna: 'Antenna',
            screw: 'Screw',
            sideSpeakerGrill: 'Speaker Grill',
            chargingConnector: 'Charging Connector',
            simCardSlot: 'SIM Card Slot',
            customDecal: 'Custom Decal',
          },
          position: 'Position',
          width: 'Width',
          height: 'Height',
          depth: 'Depth',
          chamfer: 'Chamfer',
          cornerRadius: 'Corner Radius',
          gap: 'Gap',
          diameter: 'Diameter',
          pattern: 'Pattern',
          pinHoleOffset: 'Pin Hole',
          muted: 'Muted',
        },
        customDecal: {
          size: 'Size',
          rotation: 'Rotation',
          position: 'Position',
          alongEdge: 'Position',
        },
        materials: {
          title: 'Materials',
          body: 'Body',
          frontFace: 'Front Face',
          buttons: 'Buttons',
          antennas: 'Antennas',
          screws: 'Screws',
          frontSpeaker: 'Front Speaker',
          speakerGrill: 'Speaker Grill',
          chargingConnector: 'Charging Connector',
          chargingConnectorTongue: 'Tongue',
          chargingConnectorRim: 'Rim',
          color: 'Color',
          metalness: 'Metalness',
          roughness: 'Roughness',
          clearcoat: 'Clearcoat',
          clearcoatRoughness: 'Clearcoat Roughness',
          reflectivity: 'Reflectivity',
          noiseIntensity: 'Noise',
          normalStrength: 'Normal Map',
          normalPattern: 'Pattern',
          brushed: 'Brushed Metal',
          noise: 'Noise',
        },
      },
      leftSidebar: {
        screenImage: 'Screen Image',
        export: 'Export',
      },
      freeSidebar: {
        openControls: 'Open controls',
      },
      freeInfoColumn: {
        ariaLabel: 'Full editor features',
        eyebrow: 'The full editor',
        heading: 'There’s a lot more under the hood.',
        sub: 'Sign up to unlock the full editor — no subscription, just render credits when you’re ready to export.',
        feats: {
          save: {
            label: 'Save & reuse projects',
            desc: 'Your scenes stick around. Open them anytime.',
          },
          scenes: {
            label: 'Multiple scenes per project',
            desc: 'Whole shoots in one place. Switch instantly.',
          },
          device: {
            label: 'Fully customizable devices',
            desc: 'Size, screen features, buttons, colors, materials — tune every detail.',
          },
          catalog: {
            label: 'Growing device catalog',
            desc: 'A growing line-up of Apple & Android devices.',
          },
          fork: {
            label: 'Fork & publish',
            desc: 'Fork any public project. Publish yours and earn free render credits.',
          },
          lights: {
            label: 'Advanced lights & shadows',
            desc: 'Three lights, soft shadows, HDRI environments.',
          },
          text: {
            label: '2D & 3D text',
            desc: 'Drop headlines into the scene. Style and position them freely.',
          },
          sprites: {
            label: '2D & 3D sprites',
            desc: 'PNG image stickers — flat callouts or planes in the 3D scene with shadows.',
          },
          carousel: {
            label: 'Carousel export',
            desc: 'One wide composition sliced into 2–5 store-ready carousel frames.',
          },
          noSub: {
            label: 'No subscription',
            desc: 'Pay only for the renders you export. Editor stays free.',
          },
        },
        cta: 'Sign up — it’s free',
        ctaHint: '(no credit card required)',
        miniPrompt: 'Like what you see? Save your work, fork others, and skip the subscription.',
      },
      text2d: {
        title: '2D Text',
        addText: 'Add Text',
        placeholder: 'Your Text',
        fontFamily: 'Font',
        fontSize: 'Size',
        bold: 'Bold',
        italic: 'Italic',
        alignLeft: 'Align left',
        alignCenter: 'Align center',
        alignRight: 'Align right',
        alignJustify: 'Justify',
        color: 'Color',
        position: 'Position',
        rotation: 'Rotation',
        remove: 'Remove',
      },
      text3d: {
        title: '3D Text',
        addText: 'Add 3D Text',
        placeholder: 'Your Text',
        fontFamily: 'Font',
        fontSize: 'Size',
        depth: 'Depth',
        bold: 'Bold',
        italic: 'Italic',
        alignLeft: 'Align left',
        alignCenter: 'Align center',
        alignRight: 'Align right',
        alignJustify: 'Justify',
        color: 'Color',
        position: 'Position',
        rotation: 'Rotation',
        unlit: 'Unlit (no lighting and shadows)',
        material: 'Material',
        remove: 'Remove',
      },
      sprite2d: {
        title: '2D Sprites',
        add: 'Add Sprite',
        remove: 'Remove',
        scale: 'Scale',
        position: 'Position',
        rotation: 'Rotation',
      },
      sprite3d: {
        title: '3D Sprites',
        add: 'Add 3D Sprite',
        remove: 'Remove',
        scale: 'Scale',
        position: 'Position',
        rotation: 'Rotation',
        unlit: 'Unlit (no lighting and shadows)',
        material: 'Material',
      },
      sprite: {
        upload: 'Upload Image',
        uploading: 'Uploading…',
        dropHere: 'Drop image here',
        formatHint: 'PNG recommended for transparency.',
        invalidType: 'Only JPEG, PNG, and WebP images are supported.',
        tooLarge: 'Image must be smaller than 5 MB.',
        uploadError: "Oops, couldn't upload the image. Please try again.",
      },
      screenImage: {
        title: 'Screen Image',
        upload: 'Upload Image',
        dropHere: 'Drop image here',
      },
      exportResolution: {
        title: 'This Scene Export Resolution',
        width: 'Width',
        height: 'Height',
        preset: 'Preset',
        exportFrame: 'Export Frame',
        carousel: 'Carousel',
        carouselCount: 'Frames',
        carouselHint: 'Renders one wide image, then slices it into {{count}} frames',
        carouselGap: 'Gap between frames',
        carouselGapHint:
          'Empty space between frames, matching the gap the App Store shows between screenshots so the composition stays aligned. Each frame keeps its full resolution.',
        custom: 'Custom',
      },
      exportDialog: {
        title: 'Export',
        download: 'Download PNG',
        downloadAll: 'Download All (ZIP)',
        downloadCarousel: 'Download Carousel (ZIP)',
        downloadFrame: 'Download frame {{index}}',
        carouselLabel: 'Carousel — {{count}} frames',
        frameLabel: 'Frame {{index}} of {{total}}',
        close: 'Close',
        rendering: 'Rendering preview…',
        renderingScene: 'Rendering scene {{index}} of {{total}}…',
        sceneLabel: 'Scene {{index}}',
        postProcessing: 'Post Processing',
        insufficientCredits: 'Not enough credits to export. Please purchase more credits.',
        renderChargeError: 'Failed to process render charge. Please try again.',
        webglContextLost:
          'Rendering ran out of graphics memory and was interrupted. This usually happens on mobile devices — please try again on a desktop browser.',
        creditCost_one: '{{count}} credit',
        creditCost_other: '{{count}} credits',
      },
      loading: {
        generatingModel: 'Generating model…',
      },
      projectGallery: {
        title: 'Projects',
        subtitle: 'Browse projects. Click to open in editor.',
        error: 'Failed to load projects.',
      },
      templates: {
        eyebrow: 'Projects',
        titlePrefix: 'Start from a',
        titleEm: 'ready-made',
        titleSuffix: 'project.',
        subtitle:
          'Hand-picked projects from the Ecranify team and the community — open one, swap your screens, export.',
        empty: 'No projects match your filters.',
        error: "Oops, couldn't load the projects. Please try again.",
        shareCta: {
          title: 'Share your project',
          pill: '+ free credits',
          sub: 'Proud of your project? Share it with others and earn free credits.',
        },
        toolbar: {
          sort: 'Sort',
          sortFeatured: 'Featured',
          sortNewest: 'Newest',
          sortHottest: 'Hottest',
          show: 'Show',
          showAll: 'All',
          showFree: 'Free',
          showPremium: 'Premium',
          filters: 'Filters',
          colors: 'Colors',
          tags: 'Tags',
          allTags: 'All tags',
          selected: '{{count}} selected',
          clearAll: 'Clear all',
          noTags: 'No tags yet.',
        },
        card: {
          free: 'Free',
          featured: 'Featured',
          today: 'today',
          daysAgo: '{{count}}d ago',
        },
      },
      topBar: {
        help: 'Help',
        untitledProject: 'Untitled project',
        openFullEditor: 'Open full editor',
        renameProject: 'Rename project',
      },
      toolbar: {
        save: 'Save',
        saveProject: 'Save Project',
        projectNamePlaceholder: 'Project name',
        cancel: 'Cancel',
        addScene: 'Add Scene',
        sceneName: 'Scene name',
        copyCurrentScene: 'Copy Current Scene',
        newScene: 'New Scene',
        renameScene: 'Rename Scene',
        rename: 'Rename',
        removeScene: 'Remove',
        removeSceneTitle: 'Remove {{name}}?',
        leaveTitle: 'Unsaved Changes',
        leaveMessage: 'You have unsaved changes. What would you like to do?',
        saveAndLeave: 'Save & Leave',
        leaveWithoutSaving: 'Leave without saving',
        saveFailed: "Oops, couldn't save the project. Please try again.",
        saveSuccess: 'Project saved.',
        saveDevice: 'Save device preset (dev)',
        saveDeviceFailed: "Oops, couldn't save the device JSON.",
        saveProjectPreset: 'Save project preset (dev)',
        presetTitleDevice: 'Save device preset',
        presetTitleProject: 'Save project preset',
        presetPricing: 'Pricing',
        presetFree: 'Free',
        presetPremium: 'Premium',
        presetTags: 'Tags',
        presetTagsPlaceholder: 'comma, separated, tags',
        presetDescription: 'Description',
        presetDescriptionPlaceholder: 'Short description shown in the gallery',
        presetFeatured: 'Featured',
        presetSave: 'Save preset',
        presetSaved: 'Preset written to assets/.',
        savePresetFailed: "Oops, couldn't write the preset.",
        renameFailed: "Oops, couldn't rename the project. Please try again.",
      },
      projects: {
        title: 'My Projects',
        newProject: 'New Project',
        empty: 'No projects yet. Create one from the editor.',
        delete: 'Delete',
        confirmDelete: 'Delete this project?',
        cancel: 'Cancel',
        share: 'Share',
        unshare: 'Unshare',
        shared: 'Shared',
        loadError: "Oops, couldn't load your projects. Please try again.",
        retry: 'Retry',
        deleteFailed: "Oops, couldn't delete the project. Please try again.",
        renameFailed: "Oops, couldn't rename the project. Please try again.",
        updateFailed: "Oops, couldn't save the change. Please try again.",
        shareFailed: "Oops, couldn't update sharing. Please try again.",
      },
      errors: {
        generic: 'Something went wrong. Please try again.',
        network: 'No internet connection. Please check your network.',
        server: 'Our server hiccuped. We’ve been notified.',
        unauthorized: 'Please sign in to continue.',
        forbidden: 'You don’t have permission for this.',
        webglLost: 'Your graphics card lost the connection. Reloading the viewport.',
        modelLoadTimeout:
          'The 3D model is taking too long to load. Some assets may have failed — please try reloading.',
      },
      sorry: {
        title: 'Sorry, something went wrong.',
        description: 'An unexpected error occurred. We’ve logged it and are looking into it.',
        reload: 'Reload',
        goHome: 'Go home',
        notFound: {
          title: 'Page not found',
          description: 'The page you’re looking for doesn’t exist.',
        },
      },
      editor: {
        viewport: {
          crashed: 'Viewport crashed.',
          crashedDescription: 'The 3D scene hit an unexpected error. Reload to try again.',
        },
      },
      myProjects: {
        eyebrow: 'My Projects',
        welcomePrefix: 'Welcome back,',
        welcomeFallback: 'Welcome back.',
        subtitle: 'Your projects, all in one place. Click any title or description to rename it inline.',
        stats: {
          projects: 'Projects',
          scenesTotal: 'Scenes total',
          publicProjects: 'Public projects',
          renderCredits: 'Render credits',
          creditsLeft: 'left',
          buyMore: 'Buy more',
          storage: 'Storage used',
          storageOf: 'of {{total}} MB',
        },
        hint: {
          title: 'Looking for an old export?',
          body: "Every render you've made is kept online for 30 days — redownload anytime, no extra credits.",
          cta: 'Open Render History',
        },
        empty: {
          title: 'No projects yet',
          body: 'Start from a blank canvas, or fork one of our hand-picked templates to get rolling in seconds.',
          cta: 'Create your first project',
        },
        card: {
          openProject: 'Open project',
          namePlaceholder: 'Untitled project',
          descPlaceholder: 'Add a short description…',
          tagsPlaceholder: 'Add tags…',
          tagsAria: 'Tags for {{name}}',
          nameAria: 'project name',
          descAria: 'project description',
          edit: 'Edit',
          save: 'Save',
          makePublic: 'Make public',
          unshare: 'Unshare',
          forks_one: '{{count}} fork',
          forks_other: '{{count}} forks',
          today: 'today',
          daysAgo_one: '{{count}} day ago',
          daysAgo_other: '{{count}} days ago',
        },
        delete: {
          short: 'Delete',
          title: 'Delete "{{name}}"?',
          body: "This permanently deletes the project, its scenes, and any unrendered exports. This can't be undone.",
          confirm: 'Delete project',
          cancel: 'Cancel',
        },
        share: {
          publishTitle: 'Make "{{name}}" public?',
          publishBody:
            "Anyone with the link will be able to view and fork your project. You'll earn credits when they do. You can unshare anytime.",
          publishNotice:
            'Heads up: it may take a few minutes before your project appears for other users — we render its public preview in the background.',
          publishConfirm: 'Make public',
          publicTitle: '"{{name}}" is public',
          publicBody_one:
            'Anyone with the link can view and fork it. {{count}} fork so far. You earn credits whenever someone forks.',
          publicBody_other:
            'Anyone with the link can view and fork it. {{count}} forks so far. You earn credits whenever someone forks.',
          currentlyPublic: 'Currently public',
          unshareConfirm: 'Unshare project',
          cancel: 'Cancel',
        },
      },
      storage: {
        used: '{{used}} MB of {{total}} MB used',
      },
      features: {
        eyebrow: 'Features',
        titlePrefix: "The mockup tool that's",
        titleEm: 'actually 3D',
        titleSuffix: '.',
        subtitle:
          "Four things Ecranify does that the screenshot-pasting crowd can't. Read the differentiators, then open the editor.",
        capsEyebrow: 'Editor',
        capsTitlePrefix: "Everything else you'd want,",
        capsTitleEm: 'built in',
        capsTitleSuffix: '.',
        capsSubtitle:
          'The 3D engine is the headline. These are the day-to-day quality-of-life features that make a launch take hours, not weeks.',
        cta: {
          title: 'Open the editor — no card needed.',
          body: 'The full editor is free forever. You only spend credits when you click Export, and you keep every render in your account.',
          primary: 'Start building',
          secondary: 'Browse projects',
        },
        privacy: {
          viewersSee: 'What viewers see',
          youKeep: 'You keep',
          publish: 'You publish',
          fork: 'They fork',
          earn: 'You earn',
        },
        diff: {
          tagline: 'Tagline',
        },
        capabilities: {
          undo: {
            title: 'Smart undo / redo',
            body: 'Per-scene history with slider merge logic. Drag a slider 200 times, undo once.',
          },
          text: {
            title: '2D + 3D text & sprites',
            body: 'Native typography and PNG image stickers — in screen space for crisp callouts, or in world space with real lighting, shadows, and PBR materials.',
          },
          lighting: {
            title: 'Lighting & HDR environments',
            body: 'Studio rigs, exterior daylight, neon, sunset, overcast — pick the mood from the prefab library.',
          },
          backgrounds: {
            title: 'Backgrounds, your way',
            body: 'Pick a gradient, upload your own image, or drop in one of dozens of hand-tuned prefabs. Behind every device, exactly what you want.',
          },
          export: {
            title: 'Store-ready export presets',
            body: 'Every current App Store and Play Store resolution, plus custom sizes for the web.',
          },
          mobile: {
            title: 'Mobile editor',
            body: "Drawer-pattern UI on touch. Yes, you can ship from a phone — you probably shouldn't, but you can. We won't judge.",
          },
        },
      },
      iconGenerator: {
        hero: {
          eyebrow: 'Free tool',
          titlePrefix: 'App icons,',
          titleEm: 'in one drop.',
          subtitle:
            'Upload one image, fine-tune the crop, background and an optional label, then download every iOS and Android icon size in a single ZIP. Runs entirely in your browser — nothing uploaded, nothing tracked.',
        },
        sections: {
          source: 'Source image',
          background: 'Background',
          textStrip: 'Label strip (optional)',
          preview: 'Preview',
          platforms: 'Platforms',
        },
        upload: {
          dropHere: 'Drop an image here',
          pick: 'Pick file',
          replace: 'Replace',
          clear: 'Remove',
          busy: 'Loading…',
          hint: 'PNG, JPEG, WebP — up to 5 MB. Square sources work best.',
          previewAlt: 'Source image preview',
          invalidType: 'Unsupported file type. Use PNG, JPEG, or WebP.',
          tooLarge: 'Image is larger than 5 MB. Pick a smaller file.',
          failed: 'Could not load that image. Try another file.',
        },
        crop: {
          dropHere: 'Drop an image here, or pick one on the left',
          dropReplace: 'Drop to replace',
          zoom: 'Zoom',
          reset: 'Reset',
        },
        preview: {
          tip: 'Drag inside the preview to pan. Scroll or use the slider to zoom.',
        },
        bg: {
          color: 'Solid',
          gradient: 'Gradient',
          fillColor: 'Fill',
          stopColor: 'Stop color',
          removeStop: 'Remove stop',
          angle: 'Angle',
          tip: 'Click the gradient bar to add a stop, drag a stop to move it.',
        },
        text: {
          enable: 'Show label strip',
          placeholder: 'PRO',
          stripColor: 'Strip color',
          textColor: 'Text color',
        },
        platform: {
          ios: {name: 'iOS — App Store'},
          android: {name: 'Android — Play Store'},
          fileCount_one: '{{count}} file',
          fileCount_other: '{{count}} files',
        },
        download: {
          cta: 'Download ZIP',
          busy: 'Packaging…',
          needImage: 'Upload an image to enable downloads.',
          needPlatform: 'Select at least one platform.',
          failed: 'Something went wrong while packaging the ZIP.',
        },
        dialog: {
          title: 'Rendering your icons…',
          readyTitle: 'Your icons are ready',
          preparing: 'We are slicing your image into every requested size. This takes a few seconds.',
          ready: 'Click the button to download the ZIP.',
          download: 'Download ZIP',
          progressLabel: 'Render progress',
          close: 'Close',
          ad: {
            ariaLabel: 'Also need App Store screenshots?',
            eyebrow: 'By the way',
            heading: 'Going to ship this on the App Store?',
            sub: 'You will also need store screenshots. We make those too — photorealistic 3D device mockups, rendered live in your browser. Try the free editor while your ZIP finishes.',
            feats: {
              mockup: {
                label: '3D device mockups',
                desc: 'iPhone, iPad, Pixel and more — fully posable, with real lighting and shadows.',
              },
              carousel: {
                label: 'App Store & Play Store presets',
                desc: 'Every store-required resolution, plus carousel slicing for 2–5 frames.',
              },
              free: {
                label: 'Free editor, no signup',
                desc: 'Try the full 3D mockup editor right now. Pay only when you export.',
              },
            },
            cta: 'Try the free editor',
            ctaHint: '(no card, no signup)',
          },
        },
        seo: {
          title: 'What makes a good app icon?',
          body1:
            'An app icon has to work as a tiny square everywhere at once: the App Store, the Play Store, a home screen, search results, notifications. Both stores also require the same artwork at a long list of exact pixel sizes — from a 1024×1024 store listing image down to a 20×20 notification glyph — so a single mismatched size is a real, common reason a submission gets rejected.',
          body2:
            'This tool takes one source image, lets you crop and reposition it, add a solid or gradient background and an optional label strip, then renders and packages every required iOS and Android size into one ZIP — generated locally in your browser, nothing uploaded.',
        },
        cta: {
          title: 'Also need App Store screenshots?',
          body: 'Ecranify turns your screenshots into photorealistic 3D App Store and Google Play mockups — rendered live in your browser. Free to start, pay only when you export.',
        },
      },
      qrGenerator: {
        hero: {
          eyebrow: 'Free tool',
          titlePrefix: 'QR codes,',
          titleEm: 'styled your way.',
          subtitle:
            'Build a QR code for a link, WiFi network, contact card, event and more. Style it with a solid color or gradient, drop a logo in the middle, and export as PNG, JPG, WEBP or SVG. Runs entirely in your browser.',
        },
        sections: {
          type: 'QR code type',
          content: 'Content',
          preview: 'Preview',
          style: 'Style',
          logo: 'Center logo',
        },
        types: {
          url: 'Website',
          text: 'Plain text',
          email: 'Email',
          phone: 'Phone call',
          sms: 'SMS',
          whatsapp: 'WhatsApp',
          wifi: 'WiFi',
          vcard: 'Contact card',
          event: 'Calendar event',
          location: 'Location',
        },
        fields: {
          url: 'Website URL',
          text: 'Text',
          phone: 'Phone number',
          email: 'Email address',
          subject: 'Subject (optional)',
          message: 'Message (optional)',
          whatsappHint: 'Opens a WhatsApp chat with this number and pre-filled message when scanned.',
          wifiSsid: 'Network name (SSID)',
          wifiEncryption: 'Security',
          wifiPassword: 'Password',
          wifiNoPassword: 'None (open network)',
          wifiHidden: 'Hidden network',
          firstName: 'First name',
          lastName: 'Last name',
          organization: 'Organization (optional)',
          website: 'Website (optional)',
          eventTitle: 'Event title',
          eventStart: 'Starts',
          eventEnd: 'Ends (optional)',
          eventLocation: 'Location (optional)',
          eventDescription: 'Description (optional)',
          latitude: 'Latitude',
          longitude: 'Longitude',
        },
        style: {
          pattern: 'Dot pattern',
          patterns: {
            square: 'Square',
            dots: 'Dots',
            rounded: 'Rounded',
            classy: 'Classy',
            classyRounded: 'Classy rounded',
            extraRounded: 'Extra rounded',
          },
          solid: 'Solid',
          gradient: 'Gradient',
          color: 'Color',
          stopColor: 'Stop color',
          removeStop: 'Remove stop',
          gradientTip: 'Click the gradient bar to add a stop, drag a stop to move it.',
          angle: 'Angle',
          transparentBg: 'Transparent background',
          bgColor: 'Background',
        },
        logo: {
          enable: 'Add a logo in the center',
          upload: 'Upload image',
          busy: 'Loading…',
          useDefault: 'Use Ecranify logo',
          previewAlt: 'Center logo preview',
          size: 'Size',
          margin: 'Margin',
          tip: 'A logo covers part of the code — we automatically raise the error correction level so it still scans.',
          invalidType: 'Unsupported file type. Use PNG, JPEG, or WebP.',
          tooLarge: 'Image is too large. Pick a smaller file.',
          failed: 'Could not load that image. Try another file.',
        },
        preview: {
          empty: 'Fill in the fields on the left to preview your QR code.',
        },
        download: {
          busy: 'Generating…',
          needData: 'Fill in the required fields to enable downloads.',
          failed: 'Something went wrong while generating the file.',
        },
        seo: {
          title: 'What is a QR code generator?',
          body1:
            'A QR code is a small square barcode that a phone camera can scan to instantly open a link, join a WiFi network, save a contact, add a calendar event, or start a chat — no typing required. This tool supports the most common formats: websites, plain text, email, phone, SMS, WhatsApp, WiFi, contact cards (vCard), calendar events and geo locations.',
          body2:
            'Every code is generated locally in your browser — nothing you type is uploaded anywhere. Customize the pattern color or gradient, drop a logo in the middle for branding, and download in PNG, JPG, WEBP or SVG at print-ready resolution.',
        },
        cta: {
          title: 'Also shipping a mobile app?',
          body: 'Ecranify turns your screenshots into photorealistic 3D App Store and Google Play mockups — rendered live in your browser. Free to start, pay only when you export.',
        },
        dialog: {
          title: 'Preparing your QR code…',
          readyTitle: 'Your QR code is ready',
          preparing: 'We are generating your file. This takes a few seconds.',
          ready: 'Click the button to download.',
          download: 'Download',
          progressLabel: 'Render progress',
          close: 'Close',
          ad: {
            ariaLabel: 'Also need App Store screenshots?',
            eyebrow: 'By the way',
            heading: 'Also building an app?',
            sub: 'You will probably need App Store screenshots too. We make those — photorealistic 3D device mockups, rendered live in your browser. Try the free editor while your file finishes.',
            feats: {
              mockup: {
                label: '3D device mockups',
                desc: 'iPhone, iPad, Pixel and more — fully posable, with real lighting and shadows.',
              },
              carousel: {
                label: 'App Store & Play Store presets',
                desc: 'Every store-required resolution, plus carousel slicing for 2–5 frames.',
              },
              free: {
                label: 'Free editor, no signup',
                desc: 'Try the full 3D mockup editor right now. Pay only when you export.',
              },
            },
            cta: 'Try the free editor',
            ctaHint: '(no card, no signup)',
          },
        },
      },
      imageConverter: {
        hero: {
          eyebrow: 'Free tool',
          titlePrefix: 'Image formats,',
          titleEm: 'converted instantly.',
          subtitle:
            'Convert between PNG, JPEG, WebP, GIF, BMP and ICO right in your browser. No upload, no signup — pick a file, choose a format, download.',
        },
        sections: {
          source: 'Source image',
          preview: 'Preview',
          format: 'Output format',
        },
        upload: {
          pick: 'Pick file',
          replace: 'Replace',
          clear: 'Remove',
          busy: 'Loading…',
          hint: 'PNG, JPEG, WebP, GIF, BMP, ICO — up to 25 MB.',
          previewAlt: 'Source image preview',
          gifHint: 'Animated GIFs are read as their first frame only.',
          invalidType: 'Unsupported file type.',
          tooLarge: 'Image is larger than 25 MB. Pick a smaller file.',
          failed: 'Could not load that image. Try another file.',
        },
        preview: {
          dropHint: 'Drop an image here, or pick one on the left, to see a live preview.',
          cropStart: 'Trim image',
          cropApply: 'Apply trim',
          cropApplying: 'Trimming…',
          cropCancel: 'Cancel',
        },
        format: {
          quality: 'Quality',
          icoSizes: 'Sizes to include',
          gifHint: 'Exported as a static (single-frame) GIF.',
          estimatedSize: 'Estimated file size:',
        },
        download: {
          cta: 'Convert & download',
          busy: 'Converting…',
          needImage: 'Upload an image to enable downloads.',
          failed: 'Something went wrong while converting the image.',
        },
        dialog: {
          title: 'Converting your image…',
          readyTitle: 'Your image is ready',
          preparing: 'We are converting your file. This takes a few seconds.',
          ready: 'Click the button to download.',
          download: 'Download',
          progressLabel: 'Conversion progress',
          close: 'Close',
          ad: {
            ariaLabel: 'Also need App Store screenshots?',
            eyebrow: 'By the way',
            heading: 'Also building an app?',
            sub: 'You will probably need App Store screenshots too. We make those — photorealistic 3D device mockups, rendered live in your browser. Try the free editor while your file finishes.',
            feats: {
              mockup: {
                label: '3D device mockups',
                desc: 'iPhone, iPad, Pixel and more — fully posable, with real lighting and shadows.',
              },
              carousel: {
                label: 'App Store & Play Store presets',
                desc: 'Every store-required resolution, plus carousel slicing for 2–5 frames.',
              },
              free: {
                label: 'Free editor, no signup',
                desc: 'Try the full 3D mockup editor right now. Pay only when you export.',
              },
            },
            cta: 'Try the free editor',
            ctaHint: '(no card, no signup)',
          },
        },
        seo: {
          title: 'Why convert between image formats?',
          body1:
            'PNG, JPEG, WebP, GIF, BMP and ICO each solve a different problem. PNG is lossless and keeps transparency — best for logos, icons and anything edited again later. JPEG trades some quality for much smaller files — best for photos. WebP usually beats both at the same visual quality and is the right default for the modern web. BMP and ICO exist mainly for legacy or platform-specific needs (BMP for old software, ICO for Windows icons).',
          body2:
            'This tool converts between all six, both directions, entirely in your browser — nothing is uploaded. The preview shows a live simulation of JPEG/WebP compression as you move the quality slider, includes a crop tool, and displays the exact output file size for your current settings.',
        },
        cta: {
          title: 'Also need App Store screenshots?',
          body: 'Ecranify turns your screenshots into photorealistic 3D App Store and Google Play mockups — rendered live in your browser. Free to start, pay only when you export.',
        },
      },
      videoToGif: {
        hero: {
          eyebrow: 'Free tool',
          titlePrefix: 'Video to GIF,',
          titleEm: 'trimmed and optimized.',
          subtitle:
            'Upload a video, pick a start and end point, and convert it to an optimized GIF. Runs server-side for reliable results on any device.',
        },
        sections: {
          source: 'Source video',
          trim: 'Trim',
          settings: 'Output settings',
          download: 'Download',
        },
        upload: {
          pick: 'Pick file',
          replace: 'Replace',
          clear: 'Remove',
          busy: 'Loading…',
          hint: 'MP4, WebM, MOV — up to 500 MB.',
          loadedInfo: '{{duration}}s · {{width}}×{{height}}',
          invalidType: 'Unsupported file type. Use MP4, WebM, or MOV.',
          tooLarge: 'Video is larger than 500 MB. Pick a smaller file.',
          tooLong: 'Video is longer than 30 minutes. Pick a shorter file.',
          failed: 'Could not load that video. Try another file.',
        },
        trim: {
          needVideo: 'Drop a video here, or pick one on the left, to trim it.',
          generatingPreview: 'Generating preview…',
        },
        settings: {
          resolution: 'Resolution',
          fps: 'Frame rate',
          quality: 'Quality (colors)',
          qualityHint: 'More colors look better but make a larger file — 256 is the max a GIF supports.',
          durationHint: 'Converting {{seconds}}s of video.',
          estimatedSize: 'Estimated file size (rough range, varies with content):',
        },
        download: {
          cta: 'Convert & download',
          verifying: 'Verifying…',
          busy: 'Converting…',
          busyProgress: 'Converting… {{percent}}%',
          needVideo: 'Upload a video to enable downloads.',
          recaptchaFailed: 'Verification failed. Please try again.',
          failed: 'Something went wrong while converting the video.',
        },
        dialog: {
          title: 'Converting your video…',
          readyTitle: 'Your GIF is ready',
          preparing: 'We are converting your video on our server. This can take up to a minute depending on length.',
          ready: 'Click the button to download.',
          download: 'Download',
          progressLabel: 'Conversion progress',
          close: 'Close',
          ad: {
            ariaLabel: 'Also need App Store screenshots?',
            eyebrow: 'By the way',
            heading: 'Also building an app?',
            sub: 'You will probably need App Store screenshots too. We make those — photorealistic 3D device mockups, rendered live in your browser. Try the free editor while your GIF finishes.',
            feats: {
              mockup: {
                label: '3D device mockups',
                desc: 'iPhone, iPad, Pixel and more — fully posable, with real lighting and shadows.',
              },
              carousel: {
                label: 'App Store & Play Store presets',
                desc: 'Every store-required resolution, plus carousel slicing for 2–5 frames.',
              },
              free: {
                label: 'Free editor, no signup',
                desc: 'Try the full 3D mockup editor right now. Pay only when you export.',
              },
            },
            cta: 'Try the free editor',
            ctaHint: '(no card, no signup)',
          },
        },
        seo: {
          title: 'Why convert video to GIF?',
          body1:
            'A GIF autoplays anywhere a video usually can’t — inline in a chat message, a forum post, a README, a tweet, an email — with no player controls and no tap-to-play. That single property is why short clips still get converted to GIF constantly, video codecs aside.',
          body2:
            'Upload a clip, pick a start and end point, choose a resolution and frame rate, and conversion runs on our server with a real ffmpeg encode — including the two-pass palette technique that keeps a converted GIF from banding, which a naive conversion skips. Server-side processing means a long clip on an old phone converts as reliably as a short one on a desktop.',
        },
        cta: {
          title: 'Also need App Store screenshots?',
          body: 'Ecranify turns your screenshots into photorealistic 3D App Store and Google Play mockups — rendered live in your browser. Free to start, pay only when you export.',
        },
      },
      creativeAssets: {
        hero: {
          eyebrow: 'Free tool',
          titlePrefix: 'Get even more App Store downloads',
          titleEm: 'with the new asset types.',
          subtitle:
            'Stand out at the top of your product page and in search with the iOS 27 Header, Search Results and Universal assets — as exact-size images or a looping video. Free, in your browser, nothing is uploaded.',
        },
        panels: {
          background: 'Background',
          content: 'Content',
          text: 'Text',
        },
        animation: {
          title: 'Video animation',
          background: 'Background',
          content: 'Content',
          timing: 'Timing',
          speed: 'Speed',
          speedHint:
            'Speed is how many times the movement repeats during the video, so the loop always stays seamless.',
          bgTypes: {none: 'Still', pan: 'Pan', zoom: 'Zoom'},
          contentTypes: {none: 'Still', float: 'Float', slide: 'Slide', slideshow: 'Slideshow', scroll: 'Scroll'},
          optionLabels: {
            pan: 'Axis',
            slide: 'Axis',
            float: 'Motion',
            zoom: 'Focus',
            scroll: 'Direction',
            slideshow: 'Transition',
          },
          directions: {
            horizontal: 'Horizontal',
            vertical: 'Vertical',
            diagonal: 'Diagonal',
            circle: 'Orbit',
            center: 'Center',
            left: 'Left',
            right: 'Right',
            up: 'Top',
            down: 'Bottom',
            fade: 'Fade',
            blur: 'Blur',
            push: 'Push',
            cover: 'Cover',
            scale: 'Scale',
          },
        },
        mode: {
          image: 'Image',
          video: 'Video',
        },
        video: {
          duration: 'Length',
          spec: 'MP4 (H.264), {{width}} × {{height}}, {{seconds}} s at {{fps}} fps, loops seamlessly. Apple accepts 5–30 s at 30 or 60 fps.',
          cta: 'Render & download MP4',
          busy: 'Rendering… {{percent}}%',
          unsupported:
            'Video export needs a browser with H.264 encoding (WebCodecs) — try a current Chrome, Edge or Safari.',
          browserHint:
            'Tip: upload a wide image as the background for a longer camera pan. Rendering happens in your browser, so keep this tab open — short clips take under a minute.',
          heavyHint:
            'Long clips at 60 fps are many 4K frames and can take several minutes on slower devices. 30 fps renders in half the time. You can cancel any time.',
        },
        sections: {
          keyArt: 'Key art',
          screenshots: 'Screenshots',
          icon: 'App icon',
          text: 'Text',
          preview: 'Preview',
          template: 'Layout',
          export: 'Export',
        },
        placements: {
          header: 'Header',
          search: 'Search Results',
          universal: 'Universal',
        },
        templates: {
          keyArt: {name: 'Key art', desc: 'Your artwork, centered, with an optional caption.'},
          cascade: {name: 'Cascade', desc: 'Up to three tilted screenshots climbing diagonally, headline beside them.'},
          strip: {name: 'Screenshot strip', desc: 'A row of screenshots — scrolls endlessly in video.'},
          splitText: {name: 'Split', desc: 'Big headline on the left, one screenshot on the right.'},
          iconStack: {name: 'Icon stack', desc: 'App icon above a centered headline.'},
          fan: {name: 'Screenshot fan', desc: 'Up to three screenshots fanned out, headline on the left.'},
          iconHeadline: {name: 'Icon + headline', desc: 'App icon with a headline and subline beside it.'},
          gameplay: {name: 'Gameplay crop', desc: 'One screenshot filling the frame, headline over a gradient.'},
        },
        background: {
          color: 'Solid',
          gradient: 'Gradient',
          image: 'Image',
          fill: 'Fill color',
          from: 'Start color',
          to: 'End color',
          angle: 'Angle',
          imageLabel: 'Background image',
        },
        keyArt: {
          label: 'Key art image',
          zoom: 'Zoom',
          offsetX: 'Offset X',
          offsetY: 'Offset Y',
        },
        screenshots: {
          label: 'Screenshot {{index}}',
        },
        icon: {
          label: 'App icon image',
        },
        text: {
          headline: 'Headline',
          headlinePlaceholder: 'Headline',
          subline: 'Subline',
          sublinePlaceholder: 'Subline (optional)',
          color: 'Text color',
          align: 'Alignment',
          alignOptions: {auto: 'Auto', left: 'Left', center: 'Center', right: 'Right'},
          vertical: 'Position',
          verticalOptions: {auto: 'Auto', top: 'Top', middle: 'Middle', bottom: 'Bottom'},
          weight: 'Weight',
          weightOptions: {normal: 'Normal', bolder: 'Bolder', bold: 'Bold'},
          headlineSize: 'Headline size',
          sublineSize: 'Subline size',
        },
        upload: {
          pick: 'Pick image',
          replace: 'Replace',
          clear: 'Remove',
          busy: 'Loading…',
          dropHint: 'or drop an image here',
          invalidType: 'Unsupported file type. Use PNG, JPEG or WebP.',
          tooLarge: 'Image is larger than 25 MB. Pick a smaller file.',
          failed: 'Could not load that image. Try another file.',
        },
        canvas: {
          alt: 'Live preview of the creative asset',
          showSafeArea: 'Show safe area',
          dropContent: 'Drop here: content',
          dropBackground: 'Drop here: background',
          dropTip:
            'Tip: drop an image on the preview — inside the safe area it fills the current layout, outside it becomes the background.',
          safeArea: 'Safe area',
          safeAreaNote:
            'The dashed box is an approximate safe area — Apple crops these placements differently per device and orientation, so keep important content inside it.',
        },
        download: {
          cta: 'Generate & download ZIP',
          busy: 'Generating…',
          needContent: 'Add key art, a screenshot, an icon or a headline to enable downloads.',
          formatHint: 'Header and Search Results can be PNG or JPEG. Universal is always PNG.',
          noAlpha: 'Files are exported opaque — App Store Connect rejects assets with transparency.',
          failed: 'Something went wrong while generating the files.',
        },
        dialog: {
          title: 'Generating your assets…',
          readyTitle: 'Your assets are ready',
          preparing: 'We are rendering your files at full size. This can take a little while.',
          ready: 'Click the button to download.',
          download: 'Download',
          progressLabel: 'Generation progress',
          close: 'Close',
          cancel: 'Cancel',
          eta: 'About {{time}} left',
          ad: {
            ariaLabel: 'Also need App Store screenshots?',
            eyebrow: 'By the way',
            heading: 'Need the screenshots too?',
            sub: 'Creative assets sit next to your screenshots on the product page. We make those — photorealistic 3D device mockups, rendered live in your browser. Try the free editor while your ZIP finishes.',
            feats: {
              mockup: {
                label: '3D device mockups',
                desc: 'iPhone, iPad, Pixel and more — fully posable, with real lighting and shadows.',
              },
              carousel: {
                label: 'App Store & Play Store presets',
                desc: 'Every store-required resolution, plus carousel slicing for 2–5 frames.',
              },
              free: {
                label: 'Free editor, no signup',
                desc: 'Try the full 3D mockup editor right now. Pay only when you export.',
              },
            },
            cta: 'Try the free editor',
            ctaHint: '(no card, no signup)',
          },
        },
        seo: {
          title: 'What are App Store creative assets?',
          body1:
            'iOS 27 and iPadOS 27 add two new product-page placements: a Header image shown at the top of your page, and a Search Results asset that replaces your screenshots in search. A third Universal asset can fill both. Each has an exact pixel size, and App Store Connect rejects files with an alpha channel.',
          body2:
            'This tool renders one design into all three sizes — 3840 × 1646, 3840 × 2560 and 5244 × 2950 — keeping your content inside an approximate safe area so it survives each crop. Header and Search Results can also be exported as a seamless looping MP4. Everything runs in your browser and nothing is uploaded. Always check the final files against Apple’s current App Store Connect requirements.',
        },
        cta: {
          title: 'Also need App Store screenshots?',
          body: 'Ecranify turns your screenshots into photorealistic 3D App Store and Google Play mockups — rendered live in your browser. Free to start, pay only when you export.',
        },
      },
      tools: {
        hero: {
          eyebrow: 'Free tools',
          titlePrefix: 'Handy tools,',
          titleEm: 'no signup needed.',
          subtitle:
            'A growing set of free browser-based utilities for app developers and marketers — all run locally, no account required.',
        },
        cards: {
          iconGenerator: {
            title: 'Icon generator',
            desc: 'Turn one image into every iOS and Android app icon size, packaged as a ZIP.',
            cta: 'Open tool',
          },
          qrGenerator: {
            title: 'QR code generator',
            desc: 'Styled QR codes for URLs, WiFi, contact cards and more — with color, gradient and logo.',
            cta: 'Open tool',
          },
          imageConverter: {
            title: 'Image converter',
            desc: 'Convert between PNG, JPEG, WebP, GIF, BMP and ICO, right in your browser.',
            cta: 'Open tool',
          },
          videoToGif: {
            title: 'Video to GIF',
            desc: 'Trim a clip and turn it into an optimized, shareable GIF.',
            cta: 'Open tool',
          },
          creativeAssets: {
            title: 'App Store creative assets',
            desc: 'Header, Search Results and Universal assets for iOS 27 — as images or looping video.',
            cta: 'Open tool',
          },
        },
      },
      landing: {
        nav: {
          features: 'Features',
          projects: 'Projects',
          iconGenerator: 'Icon generator',
          qrGenerator: 'QR code generator',
          imageConverter: 'Image converter',
          videoToGif: 'Video to GIF',
          creativeAssets: 'App Store creative assets',
          tools: 'Tools',
          viewAllTools: 'View all tools',
          pricing: 'Pricing',
          buyCredits: 'Buy credits',
          about: 'About',
          newProject: 'New project',
          openMenu: 'Open menu',
          closeMenu: 'Close menu',
        },
        hero: {
          titleLine1: 'Studio-quality',
          titleLine2: 'App Store screenshots,',
          titleEmphasis: 'in your browser.',
          subtitle:
            'Photorealistic 3D device mockups for App Store and Google Play — rendered live in WebGL. No Photoshop. No render farm. Drag, tweak, export.',
          ctaBrowseTemplates: 'Browse templates',
          ctaTryFree: 'Try free editor',
        },
        preview: {
          title: 'Live editor',
        },
        prank: {
          heading: "You didn't actually think that would work, did you?",
          sub: 'The real editor, on the other hand, works just fine.',
          cta: 'Sign up to find out more',
        },
      },
      auth: {
        logIn: 'Sign in',
        email: 'Email',
        emailPlaceholder: 'you@studio.com',
        continueWithGoogle: 'Continue with Google',
        sendMagicLink: 'Email me a sign-in link',
        sending: 'Sending…',
        formHeadTitle: 'Sign in to Ecranify',
        formHeadSub: "No password. We'll email you a link.",
        divider: 'or',
        magicLinkSentTitle: 'Check your inbox',
        magicLinkSentBodyPrefix: 'We sent a sign-in link to ',
        magicLinkSentBodySuffix: '. Click it to open Ecranify. The link expires in 15 minutes.',
        magicLinkSentTipPrefix: "Didn't get it? Check spam, or ",
        magicLinkSentResend: 'try a different email',
        magicLinkSentTipSuffix: '.',
        verifying: 'Signing you in…',
        magicLinkInvalid: 'This sign-in link is invalid or has expired.',
        enterEmailToContinue: 'Enter the email you used to request the link to continue.',
        confirm: 'Confirm',
        featuresEyebrow: 'Free editor not enough?',
        featuresHeadPrefix: 'Sign in to unlock the ',
        featuresHeadEm: 'full editor',
        featuresHeadSuffix: ' — and do all this, and a whole lot more.',
        feats: {
          project: {label: 'Projects', desc: 'Save and reopen scenes anytime.'},
          shape: {label: 'Shapes & materials', desc: 'Sculpt the device. Glass, matte, brushed metal.'},
          bg: {label: 'Backgrounds', desc: 'Solid, gradient or image — your choice.'},
          light: {label: 'Lighting & shadows', desc: 'Place lights. Tune softness, color, falloff.'},
          overlays: {
            label: '2D & 3D text + sprites',
            desc: 'Headlines and image stickers — flat callouts or PBR planes in the 3D scene.',
          },
          scenes: {label: 'Multiple scenes', desc: 'Whole shoots in one project. Switch instantly.'},
          carousel: {label: 'Carousel export', desc: '2–5 sliced frames per scene for App Store galleries.'},
          pay: {label: 'Pay per render', desc: 'Only the final export costs credits. Editor is free.'},
        },
        signOut: 'Sign Out',
        myProjects: 'My Projects',
        renderHistory: 'Render History',
        error: 'Sign-in failed. Please try again.',
        backToLogin: 'Back to sign in',
        backToHome: 'Back to home',
      },
      account: {
        eyebrow: 'Account',
        greeting: {prefix: 'Hi,'},
        subtitle:
          "Edit your name and avatar, see how you've been spending credits, and grab invoices for your purchases.",
        headerMenu: {
          label: 'Account menu',
          accountSettings: 'Account settings',
          signOut: 'Sign out',
        },
        profile: {
          title: 'Profile',
          description: 'Your name and avatar appear on the projects you share.',
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email',
          save: 'Save changes',
          saving: 'Saving…',
          saved: 'Saved',
          saveError: "Oops, couldn't save your profile. Please try again.",
        },
        avatar: {
          uploadLabel: 'Upload avatar',
          change: 'Change',
          upload: 'Upload photo',
          replace: 'Replace',
          remove: 'Remove',
          notImage: 'Please choose an image file.',
          uploadError: "Oops, couldn't upload the avatar. Please try again.",
          removeError: "Oops, couldn't remove your avatar. Please try again.",
        },
        balance: {
          label: 'Render credits',
          unit: 'credits left',
          buy: 'Buy credits',
        },
        redeem: {
          title: 'Redeem a promo code',
          description: 'Got a promo code? Enter it below to add credits to your balance.',
          placeholder: 'PROMO CODE',
          button: 'Redeem',
          redeeming: 'Redeeming…',
          errorInvalid: "This promo code isn't valid.",
          errorAlreadyRedeemed: 'This promo code has already been used.',
          errorGeneric: "Oops, couldn't redeem your code. Please try again.",
        },
        history: {
          title: 'Credit history',
          description:
            "Every credit you've earned, bought or spent. Invoices for purchases are issued by our payment partner Lemon Squeezy.",
          col: {
            date: 'Date',
            activity: 'Activity',
            change: 'Change',
            balance: 'Balance',
            invoice: 'Invoice',
          },
          pill: {purchase: 'purchase', reward: 'reward', spend: 'spend', refund: 'refund'},
          loading: 'Loading credit history…',
          empty: 'No credit activity yet.',
          purchase: {
            title: '{{pack}} pack',
            meta: '{{price}} paid',
          },
          render: {
            title_one: 'Render — {{count}} scene',
            title_other: 'Render — {{count}} scenes',
          },
          forkReward: {
            title: 'Reward — your project "{{project}}" was forked',
            unknownProject: 'a deleted project',
          },
          adjustment: {title: 'Manual adjustment'},
          refund: {title: 'Refund'},
          refundStatus: {
            eligible: 'Refundable until {{date}}',
            used: 'Package used',
            expired: '14-day window passed',
            refunded: 'Refunded',
          },
          invoiceLabel: 'Invoice',
          invoiceTitle: 'Open the order page on Lemon Squeezy to fill in billing details and download a PDF invoice',
          invoiceError: "Oops, couldn't open your order page. Please try again.",
          loadError: "Oops, couldn't load your credit history. Please try again.",
          foot: {
            notice:
              'Invoices are generated on Lemon Squeezy. Click "Invoice" on a purchase to open the order page and download a PDF.',
          },
        },
        signOut: {
          signedInAs: 'Signed in as',
          button: 'Sign out',
        },
        purchaseSuccess: {
          eyebrow: 'Payment received',
          title: 'Your credits are on the way!',
          body: "Thanks for the purchase. Credits usually land in your account within a few seconds — refresh the page if you don't see the new balance yet.",
          ctaPrimary: "Awesome, let's render",
          ctaSecondary: 'Stay on this page',
        },
        redeemSuccess: {
          eyebrow: 'Promo code redeemed',
          title: '{{amount}} credits added!',
          body: 'Your promo credits are ready to use. Time to turn them into gorgeous screenshots.',
          ctaPrimary: "Awesome, let's render",
          ctaSecondary: 'Stay on this page',
        },
      },
      renderHistory: {
        eyebrow: 'Render History',
        title: 'Render history',
        subtitle:
          "Your renders are kept online for 30 days — download them again anytime during that window. Once a render expires, it can't be recovered.",
        statTotal: 'Total renders',
        statAvailable: 'Available',
        statExpired: 'Expired',
        renderCount_one: '{{count}} render',
        renderCount_other: '{{count}} renders',
        openProject: 'Open project',
        projectDeleted: 'Project no longer exists',
        projectDeletedHelp: 'This project was deleted. Renders stay until they expire.',
        download: 'Download',
        noLongerAvailable: 'No longer available',
        expired: 'Expired',
        expiryOneDay: '1 day left',
        expiryDaysLeft_one: '{{count}} day left',
        expiryDaysLeft_other: '{{count}} days left',
        fallbackSceneName: 'Scene {{n}}',
        empty: {
          title: 'No renders yet',
          body: 'Once you export a scene, it will show up here.',
        },
        loadError: "Oops, couldn't load your render history. Please try again.",
        downloadError: "Oops, couldn't start the download. Please try again.",
        requestRender: 'Request render',
        requestError: "Oops, couldn't queue the render. Please try again.",
        renderingLongInfo: 'Rendering can take several tens of minutes depending on current server load.',
        retry: 'Retry',
        deleteError: "Oops, couldn't delete the render. Please try again.",
        delete: {
          short: 'Delete',
          title: 'Delete this render?',
          body: 'This permanently deletes the stored render data and the rendered image. This cannot be undone.',
          confirm: 'Delete render',
          cancel: 'Cancel',
        },
        relativeJustNow: 'just now',
        relativeMinAgo_one: '{{count}} min ago',
        relativeMinAgo_other: '{{count}} min ago',
        relativeHoursAgo_one: '{{count}} h ago',
        relativeHoursAgo_other: '{{count}} h ago',
        relativeYesterday: 'Yesterday',
        relativeDaysAgo_one: '{{count}} day ago',
        relativeDaysAgo_other: '{{count}} days ago',
        statusPending: 'Queued',
        statusProcessing: 'Rendering…',
        statusCompleted: 'Completed',
        statusFailed: 'Failed',
      },
      pricing: {
        eyebrow: 'Pricing',
        titlePrefix: 'Pay only for what you',
        titleEm: 'actually ship',
        titleSuffix: '.',
        subtitle: 'No subscription. No surprise renewals. Buy a pack of credits, spend them when you ship.',
        loading: 'Loading packs…',
        mostPopular: 'Most popular',
        creditsLabel: 'credits',
        oneOff: 'one-off',
        perCredit: '${{amount}} / credit',
        save: 'save {{percent}}%',
        buyCredits: 'Buy {{count}} credits',
        bestForLabel: 'Best for:',
        redirecting: 'Redirecting…',
        checkoutError: 'Failed to start checkout. Please try again.',
        promise: {
          noSub: {
            title: 'No subscription',
            body: 'One-off purchase. No surprise renewals.',
          },
          expire: {
            title: 'Credits never expire',
            body: 'Use them today, next month, or in two years.',
          },
          refund: {
            title: '14-day refund',
            body: 'On any pack you haven’t started rendering from.',
          },
        },
        packs: {
          small: {
            name: 'Starter',
            tagline: 'Try it out, ship a few screens.',
            bestFor: 'Solo indie devs preparing one App Store listing.',
          },
          medium: {
            name: 'Creator',
            tagline: 'Most popular — covers a typical launch.',
            bestFor: 'Indie teams shipping for iOS + Android in multiple locales.',
          },
          large: {
            name: 'Studio',
            tagline: 'Bulk credits for agencies & studios.',
            bestFor: 'Studios launching multiple apps a year.',
          },
        },
        includedEyebrow: 'Same in every pack',
        included: {
          editor: 'Full-featured editor, free forever',
          share: 'Save & share unlimited projects',
          earn: 'Earn credits when others use your shared projects',
          devices: 'All device frames & templates',
          resolution: 'Up to 4K resolution, no watermark',
          redownload: 'Re-download paid renders anytime from your profile',
          expire: 'Credits never expire',
          refund: 'Refund any pack you haven’t started using, within 14 days',
        },
        howItWorks: 'How it works',
        howTitlePrefix: 'Free editor.',
        howTitleEm: 'Pay only when you export.',
        howBody:
          'Sign up and you get the full editor straight away — build projects, add as many scenes as you want, share them with the community. Credits are spent only when you click Export.',
        howRows: {
          editor: {
            label: 'Full editor, save & share unlimited projects',
            meta: 'Free with sign-up, no card',
          },
          export: {
            label: 'Export one scene ({{count}} credits per scene)',
            meta: 'Render scenes one by one or in batch',
          },
          redownload: {
            label: 'Re-download paid renders from your profile',
            meta: 'Anytime, no extra cost',
          },
          fork: {
            label: 'Earn bonus credits when others use your shared projects',
            meta: '+{{count}} credit per fork render',
          },
        },
        faqTitle: 'Questions, answered honestly.',
        faq: {
          noSub: {
            q: 'Why no monthly subscription?',
            a: "Honestly? Most people don't need one. You ship a new app, refresh your store listing every now and then, and that's it. Charging you every month for a tool you open three times a year would be lazy pricing. Pay for what you use, when you use it.",
          },
          how: {
            q: 'How does it actually work?',
            a: 'You sign up free and get the full editor straight away — no trial, no feature gates. Build a project, add as many scenes as you want, tweak everything. Credits are only spent when you click Export. You can render scenes one by one or batch them all at once. Once a scene is paid for, you can re-download it anytime from your profile — we keep your renders.',
          },
          expire: {
            q: 'Do credits expire?',
            a: "Never. Buy 100 today, use 20 now and the rest in two years — they'll still be there. We don't punish people for working at their own pace.",
          },
          free: {
            q: 'Can I really render premium scenes for free?',
            a: "Yep — if you've got the design talent. Share a project you're proud of: every time someone uses it, you earn bonus credits. Some users render their entire launch this way without ever paying.",
          },
          refund: {
            q: 'Can I get a refund?',
            a: 'Yes — within 14 days of purchase, on any pack you haven’t started using. Credits drain from your oldest pack first, so as soon as you render with a pack it becomes non-refundable. Reach us via the contact form and we’ll process the refund through Lemon Squeezy.',
          },
          team: {
            q: 'Do you offer team or enterprise plans?',
            a: 'The Studio pack covers most teams. For larger orgs, custom invoicing, or SSO, get in touch — we do bespoke deals for studios shipping serious volume.',
          },
        },
        cta: {
          title: "Start free, export when you're ready.",
          body: 'Sign up to unlock the full editor, save and share projects — no card required. Buy credits only when you want to export.',
          openEditor: 'Open the editor',
          signUp: 'Sign up',
          browse: 'Browse projects',
        },
        consentModal: {
          title: 'Before we hand you off to checkout',
          summary:
            "You're buying <strong>{{credits}} credits — {{packageName}}</strong> for <strong>{{price}}</strong>. Credits are delivered immediately, so we need one quick confirmation.",
          consentText:
            "I'd like my credits added to my account straight away. I've read the <refund>Refund Policy</refund> and <terms>Terms of Use</terms>, and I understand that <strong>once I use any credit from this pack, it can no longer be returned for a refund</strong>.",
          confirmLabel: 'Continue to payment',
          loadingLabel: 'Redirecting …',
          cancelLabel: 'Cancel',
          errorGeneric: "Couldn't start checkout. Please try again in a moment.",
        },
      },
      contact: {
        eyebrow: 'Contact',
        titleLead: 'Talk to us —',
        titleEm: 'a real person replies.',
        lede: 'We run Ecranify as a small team. The fastest way to reach us is the form below — we triage on the same day. Bug reports, billing issues, partnership ideas: all welcome.',
        sentTitle: 'Message sent.',
        sentBody: "We'll get back to you within one business day, usually faster. Check your inbox for a copy.",
        sendAnother: 'Send another',
        cards: {
          addressTitle: 'Mailing address',
          addressBody: 'Small Water s. r. o.<br/>Dlhá 2322/32<br/>926 01 Sereď<br/>Slovak Republic',
        },
        form: {
          labelName: 'Name',
          labelEmail: 'Email',
          labelTopic: 'Topic',
          labelSubject: 'Subject',
          labelMessage: 'Message',
          placeholderName: 'Your name',
          placeholderEmail: 'you@example.com',
          placeholderSubject: 'One-line summary',
          placeholderMessage:
            "What can we help with? Include any project URLs, render IDs, or screenshots if it's a bug.",
          submit: 'Send message',
          sending: 'Sending…',
          fine: 'By submitting, you agree to our <privacy>Privacy Policy</privacy>. We never share your email or use it for marketing.',
          error: 'Something went wrong while sending your message. Please try again in a moment.',
          topics: {
            general: 'General question',
            bug: 'Bug report',
            billing: 'Billing / refunds',
          },
        },
      },
      faq: {
        eyebrow: 'FAQ & Help',
        titleLead: 'Quick answers,',
        titleEm: 'without the run-around.',
        lede: "The questions we get most often, sorted by topic. Can't find what you're looking for? <contactLink>Send us a note</contactLink> — we reply same-day.",
        categories: {
          all: 'All',
          start: 'Getting started',
          billing: 'Credits & billing',
          editor: 'The editor',
          sharing: 'Sharing & earning',
          privacy: 'Privacy & data',
        },
        groups: {
          start: {
            account: {
              q: 'Do I need an account to use the editor?',
              a: "You can browse public projects without one, but to save anything, export, or earn credits you'll need to sign up. Sign-up is free and takes ten seconds — Google or email.",
            },
            free: {
              q: 'Is there a free trial?',
              a: 'The full editor is free forever — no trial, no feature gates. You only spend credits when you export. Try the <free>free editor</free> without signing up first.',
            },
            devices: {
              q: 'What devices and resolutions are supported?',
              a: 'We currently ship the most popular iPhones, with more presets being added continuously. You can also build any device shape from primitives inside the scene editor. Export presets cover every App Store and Google Play size, and you can dial in custom dimensions for the web.',
            },
          },
          billing: {
            cost: {
              q: 'How do credits work?',
              a: 'Each exported scene costs 2 credits. The total is shown in the Export panel before you click Export. Buying credits never auto-renews — you decide when to top up.',
            },
            expire: {
              q: 'Do credits expire?',
              a: 'Never. Buy 200 today, use 50 now, the rest in two years — still there.',
            },
            refund: {
              q: 'Can I get a refund?',
              a: 'Yes — see our <refund>Refund Policy</refund> for details.',
            },
            invoice: {
              q: "Where's my invoice?",
              a: "Open your <account>Account page</account> → click any purchase in the credit ledger → 'Download invoice'. Invoices come from Lemon Squeezy, our merchant of record, and include VAT details for EU customers.",
            },
          },
          editor: {
            batch: {
              q: 'Can I batch-render every scene at once?',
              a: "Yes. Open the project → Export → 'Batch render all scenes'. We charge once for the whole batch, and you can re-download each render from your <history>Render History</history> for 30 days.",
            },
            mobile: {
              q: 'Can I work from my phone?',
              a: 'Yes — the editor adapts to a drawer-pattern UI on touch. We don\'t recommend doing a full launch from a 6" screen, but a quick tweak is fine.',
            },
            screenImage: {
              q: 'How do I put my own app screenshot on the device?',
              a: "In the right sidebar, open the <em>Screen</em> panel and drop your image (or click to pick a file). It maps onto the active scene's device screen immediately. Each project gets its own image library; uploads count against your 100 MB account quota.",
            },
            renderHistory: {
              q: 'Where do I find my past exports?',
              a: 'Open <history>Render History</history> from the user menu. Every export shows its scene, resolution, file size and expiry date. Renders are kept online for 30 days, then automatically deleted — re-export any time you need.',
            },
          },
          sharing: {
            screenPrivacy: {
              q: 'If I publish a project, can other people see my screen content?',
              a: 'No. Public project thumbnails are re-rendered with placeholder art instead of your screen image. When someone forks your project, they get a clean copy with empty screens — your unreleased UI never leaves your account.',
            },
            shareLink: {
              q: 'Can I share my project as a link?',
              a: 'Yes — every published project gets a public URL on the <projects>Projects gallery</projects>. Anyone with the link can preview the layout and fork their own copy. Your raw screen images are never included.',
            },
            forkReward: {
              q: 'How much do I earn when someone forks my project?',
              a: 'When someone forks one of your published projects, we credit you 1 credit. It lands in your account the same day.',
            },
          },
          privacy: {
            storage: {
              q: 'Where is my data stored?',
              a: 'Everything is stored on EU servers. Rendered files live in Hetzner data centers in Germany and Finland. You can request export or deletion of everything at any time — see our <privacy>Privacy Policy</privacy>.',
            },
            aiTraining: {
              q: 'Do you train AI on my projects?',
              a: "No. We don't use customer projects to train any model. There are no AI features in Ecranify — every pixel is yours.",
            },
            retention: {
              q: 'How long do you keep my renders?',
              a: "30 days online, then automatic deletion. You'll see the expiry date on every render in your history.",
            },
          },
        },
        empty: 'No questions in this category yet.',
        ctaTitle: 'Still stuck?',
        ctaBody: 'Drop us a line — we reply same-day, usually within a few hours.',
      },
      contactUsButton: {
        label: 'Contact us',
      },
      terms: {
        eyebrow: 'Terms of Use',
        titleLead: 'The deal,',
        titleEm: 'in plain words.',
        lede: "What you can do with Ecranify, what we promise in return, and the boring-but-necessary rules that keep both sides happy. We've tried to write this the way we'd want to read it.",
        metaUpdated: 'Last updated · 2026-05-21',
        metaReading: '≈ 7 min read',
        metaGoverned: 'Governed by Slovak law',
        tocLabel: 'On this page',
        toc: {
          agreement: 'The agreement',
          account: 'Your account',
          license: 'License to use the editor',
          acceptableUse: 'Acceptable use',
          content: 'Your content',
          credits: 'Credits, purchases & refunds',
          availability: 'Service availability',
          liability: 'Limits of liability',
          changes: 'Changes to these Terms',
          law: 'Governing law & disputes',
          contact: 'Contact',
        },
        sections: {
          agreement: {
            title: 'The agreement, in plain words',
            p1: 'These Terms govern your use of Ecranify — the web editor, the public project gallery, and any rendered files we produce on your behalf. By creating an account, buying credits, or rendering a scene, you accept them.',
            p2: 'Ecranify is operated by <strong>Small Water s. r. o.</strong>, registered at Dlhá 2322/32, 926 01 Sereď, Slovak Republic, company registration number 52670317. Our full registry details are on the Legal Notice page.',
            p3: 'Ecranify is operated from the European Union and is available worldwide. By using it from outside the EU, you agree that EU data-protection rules apply to your use of the service. If anything below is unclear, use the <contact>contact form</contact> and we will explain.',
            callout:
              "This is a friendly summary, not a substitute for the legal text. Where the language is plain, that's intentional — we want the bits that matter to be readable.",
          },
          account: {
            title: 'Your account',
            p1: "We sign you in with Google or with a one-time email link — there are no passwords. Whoever can read your inbox or open your Google account can sign in as you, so treat that access as you would treat any sensitive mailbox. Don't share access across a team — create a seat per person.",
            p2: 'You must be at least 16 years old to open an Ecranify account. If you are signing up on behalf of a company, you confirm that you have the authority to bind that company to these Terms.',
            p3: 'You can close your account at any time from the Account page. We may suspend or terminate an account for serious or repeated breaches of these Terms — for example fraud, automated abuse, or harmful content — and we will email you first if the situation allows it.',
          },
          license: {
            title: 'License to use the editor',
            p1: "We grant you a limited, non-exclusive, non-transferable license to use Ecranify to create, render, and export mockups for your own apps and your clients' apps. Renders you produce are yours — publish them anywhere you like: App Store, Google Play, social media, marketing sites, print.",
            p2: 'This license is conditional on your compliance with the rules in <em>Acceptable use</em> below and on the warranties about your content in <em>Your content</em>. If you breach those, the license ends until the breach is fixed.',
          },
          acceptableUse: {
            title: 'Acceptable use',
            p1: "When using Ecranify, please don't:",
            bullets: {
              resale:
                '<strong>Resell or wrap the service</strong> — no reselling access to the editor, no white-labeling, and no exposing its API or renderer on top of a third-party product without a written license from us.',
              automation:
                "<strong>Scrape or automate beyond normal use</strong> — no crawling, scraping, or programmatically downloading the project gallery beyond ordinary browsing; no automated render farms or load you wouldn't generate by hand.",
              infringing:
                "<strong>Render unlawful or infringing content</strong> — nothing that's illegal in the EU or in the place you'll publish it, that infringes someone else's intellectual-property or privacy rights, or that targets a person or group with harassment or hate.",
              impersonation:
                "<strong>Impersonate or deceive</strong> — no renders that pass off someone else's product as yours, that misrepresent who is behind an app, or that are designed to mislead end users.",
              security:
                '<strong>Abuse the platform</strong> — no malware, no probing for vulnerabilities outside a responsible-disclosure flow we agree to, no attempts to bypass rate limits, manipulate the credit ledger, or disrupt other users.',
            },
            closing:
              "If you're not sure whether what you're planning is okay, write to us first via <contact>Contact</contact> — we would much rather answer a question than ban an account.",
          },
          content: {
            title: 'Your content, your screens',
            p1: "Everything you upload — screenshots, screen recordings, logos, fonts, copy — stays yours. You grant us a narrow, technical license to host, process, render, and display that content so the service can do its job. Nothing more. We don't sell, license, or share it with third parties beyond the infrastructure providers we rely on to deliver the service.",
            p2: 'If you make a project public, the scene composition, lighting, materials, and device layout become viewable so others can fork it. Your screen images are stripped before the public thumbnail and fork are produced — they never leave your account through the public surface.',
            p3: 'You warrant that you own — or are licensed to use — every screenshot, font, logo, and piece of copy you put into Ecranify, including the right to have it rendered and exported. You are solely responsible for the legality of that content. We do not pre-screen what you upload and we are not a publisher of it. If a third party gives us a reasonably detailed notice that something you uploaded infringes their rights or breaks the law, we may remove it and tell you. You can challenge a removal by writing to us via <contact>Contact</contact>.',
            p4: 'We do not train any model on your projects, your screens, or your renders. There are no AI features in Ecranify — every pixel is yours.',
            p5: 'Rendered files are kept for 30 days from the moment they finish rendering. After that the full-resolution file is deleted and only the thumbnail remains in your render history. Please save anything you need locally before the 30-day window closes — see the <refund>Refund Policy</refund> for what happens to unused credits.',
          },
          credits: {
            title: 'Credits, purchases & refunds',
            p1: 'Renders are paid for with credits. Credits are purchased through our merchant of record, <strong>Lemon Squeezy</strong>, who handles checkout, VAT, and invoicing in your local jurisdiction. Buying credits never auto-renews — you decide when to top up.',
            p2: "Credits never expire. They are not redeemable for cash and may not be transferred between accounts. Re-downloading a render you have already paid for is free during its 30-day retention window; render history older than that is no longer downloadable, so please save what you need before then. We don't have a subscription tier.",
            p3: 'Refunds are described in our <refund>Refund Policy</refund>. Where the EU Consumer Rights Directive applies, you keep your statutory withdrawal rights regardless of anything else said here.',
          },
          availability: {
            title: 'Service availability',
            p1: "We work hard to keep Ecranify available around the clock, but we don't guarantee uptime and we don't run a paid SLA. If we plan maintenance that will take the editor offline, we will announce it at least 24 hours ahead by email and in the editor. Your projects, credits, and history are durable across downtime — nothing is lost when the service is briefly unavailable.",
          },
          liability: {
            title: 'Limits of liability',
            p1: "Ecranify is provided <strong>as-is and as-available</strong>. We don't warrant that the editor or the renderer will be uninterrupted, error-free, or fit for a particular purpose beyond what is described in these Terms and on our site.",
            p2: 'To the maximum extent permitted by law, our total liability for any claim arising out of the service is capped at the amount you paid us in the 12 months before the claim. We are not liable for indirect or consequential losses — for example lost profits, lost goodwill, or harm caused by content you chose to upload, render, or publish.',
            p3: 'If a third party brings a claim against us that arises out of content you uploaded, rendered, or published through Ecranify — including infringement of trademarks, copyrights, or privacy rights — you agree to defend us against it and to cover our reasonable legal costs, except where the claim is caused by our own breach of these Terms.',
            p4: 'Nothing here limits liability for fraud, gross negligence, death or personal injury caused by our negligence, or anything that cannot be limited under Slovak or EU consumer law. EU consumers retain their statutory rights in full.',
          },
          changes: {
            title: 'Changes to these Terms',
            p1: 'If we make a material change to these Terms, we will email everyone with an active account at least 30 days before it takes effect, and you\'ll have until then to close your account if you don\'t want to be bound by the new version. Non-material clarifications — typos, link fixes, contact-detail updates — go live immediately and are noted at the top of this page with a fresh "Last updated" date.',
          },
          law: {
            title: 'Governing law & disputes',
            p1: 'These Terms are governed by the laws of the Slovak Republic. If you are an EU consumer, you also keep the mandatory protections of the law of your country of residence — nothing in this clause overrides them.',
            p2: 'If a dispute arises, please write to us first — most disagreements get sorted within a few emails. If a good-faith exchange does not resolve it within 60 days, the competent courts of the Slovak Republic have jurisdiction. As an EU consumer you can also use the European Commission Online Dispute Resolution platform.',
          },
          contact: {
            title: 'Contact',
            p1: 'Legal questions, takedown notices, or anything that needs a wet signature:',
            addressBody: '<strong>Small Water s. r. o.</strong><br/>Dlhá 2322/32<br/>926 01 Sereď<br/>Slovak Republic',
            emailLine: 'For everything else, use the <contact>contact form</contact>.',
          },
        },
      },
      privacy: {
        eyebrow: 'Privacy Policy',
        titleLead: 'Your data,',
        titleEm: 'minimal & EU-hosted.',
        lede: 'We collect what we need to run Ecranify, nothing else. No data brokers, no AI training, no profiling. This page explains exactly what we hold, why, the legal basis, and how to get rid of it.',
        metaUpdated: 'Last updated · 2026-05-22',
        metaReading: '≈ 8 min read',
        metaGoverned: 'Governed by Slovak law',
        tocLabel: 'On this page',
        toc: {
          summary: 'Summary',
          controller: 'Data controller',
          what: 'What we collect',
          why: 'Why we use it',
          sharing: 'Who we share data with',
          where: 'Where data is stored',
          security: 'How we protect it',
          retention: 'How long we keep things',
          rights: 'Your rights under GDPR',
          age: 'Age',
          cookies: 'Cookies & tracking',
          changes: 'Changes to this policy',
          contact: 'Contact',
        },
        sections: {
          summary: {
            title: 'Summary',
            p1: "We collect the minimum we need to run Ecranify and bill you for credits. We don't sell your data. We don't train AI on your projects. We host in the EU. To export or delete everything we hold about you, just <contact>contact us</contact>.",
            callout:
              'This is the human version. The legally binding text follows below. If anything contradicts, the long form wins — but we try hard to keep them aligned.',
          },
          controller: {
            title: 'Data controller',
            p1: 'The controller of your personal data is:',
            addressBody:
              '<strong>Small Water s. r. o.</strong><br/>Dlhá 2322/32<br/>926 01 Sereď<br/>Slovak Republic<br/>Company registration: <strong>52670317</strong> · VAT: <strong>SK2121111014</strong>',
            emailLine: 'For privacy questions, use the <contact>contact form</contact>.',
          },
          what: {
            title: 'What we collect',
            account: 'Account data',
            accountBullets: {
              identity: 'Name and email (from sign-up or your Google account).',
              avatar: 'An optional avatar image you upload.',
            },
            project: 'Project data',
            projectBullets: {
              meta: 'Project metadata (names, descriptions, scene settings, color choices, tags).',
              uploads: 'Uploaded screen content (screenshots, backgrounds, sprites).',
              renders: 'Rendered output files, kept for 30 days then deleted automatically.',
            },
            billing: 'Billing data',
            billingBullets: {
              orders:
                'Order IDs from <strong>Lemon Squeezy</strong>, our merchant of record. We never see your card number or full billing address — Lemon Squeezy holds the invoice.',
              ledger: 'Credit ledger entries — purchases, spends, rewards, and your running balance.',
            },
            usage: 'Usage & diagnostics',
            usageBullets: {
              analytics:
                'Aggregated page views and feature events via <strong>Google Analytics</strong>, only after you accept the cookie banner — see the <cookies>Cookie Policy</cookies>.',
              errors:
                'Error reports from your browser via <strong>Sentry</strong> (only when configured), scrubbed of personal data before they reach us.',
              recaptcha:
                'A short-lived bot-protection token from <strong>Google reCAPTCHA v3</strong> when you submit the contact form.',
            },
          },
          why: {
            title: 'Why we use it',
            p1: 'Legal bases under the GDPR:',
            bullets: {
              contract:
                '<strong>Contract</strong> — running the editor, storing your projects, rendering exports, fulfilling your credit purchases.',
              legitimate:
                '<strong>Legitimate interest</strong> — keeping the service secure, debugging crashes, understanding which features are useful (no profiling, no ad targeting).',
              legal:
                '<strong>Legal obligation</strong> — keeping invoice and accounting records for the tax authority for the period required by Slovak law.',
              softOptIn:
                "<strong>Soft opt-in (ePrivacy Art. 13(2) / Slovak Act 452/2021 §62)</strong> — if you've completed at least one purchase, we may email you about our own similar products (credits, editor features, important updates). One-click opt-out in every email; once you opt out we don't add you back. We don't email marketing to users who have never bought anything.",
              consent:
                '<strong>Consent</strong> — for anything outside the soft opt-in (e.g. a future product newsletter for non-customers, beta invitations). Always opt-in first, opt-out any time.',
            },
          },
          sharing: {
            title: 'Who we share data with',
            p1: 'Only the processors we need to deliver the service. Each one signs an EU SCC-grade data processing agreement:',
            bullets: {
              firebase:
                '<strong>Google Firebase</strong> — authentication (Google sign-in + magic-link). Data is processed in Google data centres under EU Standard Contractual Clauses.',
              hetzner:
                '<strong>Hetzner (EU)</strong> — primary database and asset storage. Servers physically located in the European Union.',
              lemonsqueezy:
                '<strong>Lemon Squeezy</strong> — checkout, VAT handling, and invoicing. Lemon Squeezy is the merchant of record; the invoice you download from them is yours.',
              analytics:
                '<strong>Google Analytics</strong> — aggregated usage analytics (only after cookie consent, US transfer under SCCs).',
              sentry:
                '<strong>Sentry</strong> — crash reporting and error monitoring (US transfer under SCCs, only when our error-reporting integration is enabled).',
              recaptcha:
                '<strong>Google reCAPTCHA v3</strong> — contact-form spam protection (US transfer under SCCs).',
            },
            p2: 'We <strong>never</strong> sell data, share it with advertisers, or use it to train AI models. We will respond to a binding legal order only after challenging anything we believe is overbroad.',
          },
          where: {
            title: 'Where data is stored & international transfers',
            p1: 'All primary storage — database, project files, render outputs — lives inside the European Union on Hetzner infrastructure. Backups are encrypted at rest and live in the same region.',
            p2: "Some of the services we rely on (<strong>Firebase Auth, Google Analytics, Google reCAPTCHA, Sentry</strong>) are operated by US-based companies. When your personal data is transferred to them, the transfer is covered by the European Commission's Standard Contractual Clauses (SCCs) and the EU–U.S. Data Privacy Framework where applicable. We only use providers that publish current SCCs and have a credible commitment to EU data-protection standards.",
          },
          security: {
            title: 'How we protect it',
            p1: 'Concretely:',
            bullets: {
              transit: 'All traffic to Ecranify is encrypted in transit (HTTPS / TLS 1.2+). HTTP redirects to HTTPS.',
              rest: 'Backups and object storage are encrypted at rest.',
              access:
                'Production access is limited to the smallest set of people who need it, with individually scoped credentials. No shared passwords; admin actions are logged.',
              least:
                'Service accounts use least-privilege scopes — the render worker can read its own queue, not your billing data.',
              breach:
                'If a personal-data breach happens that puts you at risk, we will notify you and the Slovak Data Protection Office within 72 hours of becoming aware, as required by GDPR Art. 33–34.',
            },
          },
          retention: {
            title: 'How long we keep things',
            bullets: {
              projects:
                '<strong>Projects:</strong> until you delete them. Deleted projects are purged from backups within 30 days.',
              renders:
                '<strong>Renders:</strong> 30 days from creation, then the full-resolution file is deleted automatically. The thumbnail stays in your render history.',
              account:
                '<strong>Account:</strong> until you close it. Closing the account anonymises the credit ledger and removes personal data within 30 days.',
              billing:
                '<strong>Billing records:</strong> end-customer invoices are issued and retained by <strong>Lemon Squeezy</strong> — re-download yours any time from the receipt link in your purchase confirmation email. We keep aggregated payout statements from Lemon Squeezy for 10 years, as required by Slovak accounting law (Act 431/2002) and VAT law (Act 222/2004).',
              optOut:
                "<strong>Marketing opt-outs:</strong> permanently. Once you've unsubscribed we keep a tombstone record of the opt-out so we don't accidentally re-add you on a later purchase.",
            },
          },
          rights: {
            title: 'Your rights under GDPR',
            p1: 'Under the GDPR you may, at any time:',
            bullets: {
              access: 'Access a copy of everything we hold about you.',
              correct: "Correct anything that's wrong.",
              erase: 'Delete your account and the data attached to it.',
              restrict: 'Object to processing or restrict it.',
              portable:
                'Export your project data in a portable format — write to us and we send you a ZIP within 30 days.',
              withdraw:
                'Withdraw consent at any time, where processing relies on consent — withdrawal does not affect anything we processed lawfully before you withdrew.',
              optOut:
                'Opt out of marketing emails with a single click using the unsubscribe link in any marketing email. Once you opt out, we will not add you back without a fresh explicit opt-in from you.',
              automated:
                "No automated decisions, no profiling. We don't score, segment, or single you out automatically — nothing about your account is decided by an algorithm.",
              complain:
                "Complain to the Slovak Data Protection Office (<dpa>dataprotection.gov.sk</dpa>) if you think we've mishandled something.",
            },
            p2: 'To exercise any of these rights, <contact>contact us</contact> — we respond within 30 days, usually within 48 hours.',
          },
          age: {
            title: 'Age',
            p1: "You must be at least 16 years old to create an Ecranify account. We do not knowingly collect personal data from anyone under 16. If you believe a child has signed up, write to us and we'll close the account and delete the data.",
          },
          cookies: {
            title: 'Cookies & tracking',
            p1: 'We use the minimum set of cookies needed to run the service plus, with your consent, an analytics package:',
            bullets: {
              session:
                '<strong>Session cookie</strong> — set by Firebase Auth to keep you signed in. Essential, no consent required.',
              recaptcha:
                '<strong>reCAPTCHA cookies</strong> — set by Google reCAPTCHA on the contact form to detect bots. Essential for the form to work; cleared after the form is submitted.',
              analytics:
                '<strong>Google Analytics cookies</strong> — non-essential. Set only after you accept the cookie banner; aggregated, no profiling.',
            },
            p2: 'For the full breakdown — names, vendors, lifetimes, and the opt-out controls — see the <cookies>Cookie Policy</cookies>.',
          },
          changes: {
            title: 'Changes to this policy',
            p1: 'Material changes get a 30-day email notice — you\'ll have time to close your account if you don\'t want to be bound by the new version. Minor edits (typos, link fixes, contact-detail updates) go live immediately and are noted at the top of this page with a fresh "Last updated" date.',
          },
          contact: {
            title: 'Contact',
            p1: 'Privacy questions, data requests, takedown notices, anything that needs a wet signature:',
            addressBody: '<strong>Small Water s. r. o.</strong><br/>Dlhá 2322/32<br/>926 01 Sereď<br/>Slovak Republic',
            emailLine: 'For privacy requests of any kind, use the <contact>contact form</contact>.',
          },
        },
      },
      cookies: {
        eyebrow: 'Cookie Policy',
        titleLead: 'Cookies,',
        titleEm: 'and how to switch them off.',
        lede: 'A short, honest inventory of every cookie, browser-storage, and tracking key Ecranify uses. The strictly necessary ones keep you signed in; the optional ones (Google Analytics, Sentry) only load if you opt in below.',
        metaUpdated: 'Last updated · May 22, 2026',
        metaReading: '3 min read',
        metaGoverned: 'Governed by Slovak law',
        tocLabel: 'On this page',
        toc: {
          prefs: 'Your cookie preferences',
          intro: 'Why this page exists',
          what: 'What we use',
          not: 'What we do NOT use',
          control: 'How to control cookies',
          changes: 'Updates to this policy',
        },
        prefs: {
          strictlyNecessary: {
            title: 'Strictly necessary',
            alwaysOn: 'Always on',
            body: 'Required to sign you in, keep you signed in, and process credit purchases. Without these the service does not work, so they cannot be switched off and require no consent under ePrivacy / GDPR.',
          },
          analytics: {
            title: 'Analytics & error reporting',
            optional: 'Optional',
            body: 'Google Analytics (when we enable it) and Sentry — aggregate page views, feature usage, and crash reports so we know what to fix and what to build next. Off by default. You can change this at any time; the editor works exactly the same either way.',
          },
          actions: {
            acceptAll: 'Accept all',
            rejectOptional: 'Reject optional',
            saved: 'Preferences saved.',
          },
        },
        sections: {
          prefs: {
            title: 'Your cookie preferences',
            p1: 'Pick what you are comfortable with. Strictly necessary cookies stay on — without them you cannot sign in or buy credits. Analytics is optional and you can change it any time on this page. Your choice is stored in your browser and, if you are signed in, synced to your account so it follows you across devices.',
          },
          intro: {
            title: 'Why this page exists',
            p1: 'EU law (ePrivacy Directive, Slovak Act 452/2021, GDPR Art. 6) requires us to tell you exactly which cookies and storage technologies Ecranify uses, why, and how to control them. This page is the full inventory — no marketing copy, just the list.',
            p2: 'We do not run ad networks, retargeting pixels, or session replay. The only optional third-party tools that touch your browser are Google Analytics (for aggregate usage) and Sentry (for crash reports) — both optional, both off until you opt in above. For everything else, see the <privacy>Privacy Policy</privacy>.',
          },
          what: {
            title: 'What we use',
            auth: {
              title: 'Strictly necessary — authentication',
              bullet:
                "Sign-in is handled by <strong>Firebase Authentication</strong>, which stores your ID and refresh tokens inside the browser's <strong>IndexedDB</strong> under <code>firebaseLocalStorageDb</code> (not in cookies). First-party, encrypted in transit, only readable from this origin. Lifespan: refreshed on activity. Without it you would have to log in on every page reload. No consent required — this is the bare minimum to run the service.",
            },
            recaptcha: {
              title: 'Strictly necessary — anti-abuse',
              bullet:
                '<strong>Google reCAPTCHA v3</strong> is loaded only when you open the contact form. It sets short-lived cookies under <code>google.com</code> to score the request and block bot spam. Loaded on-demand, never on other pages. Legal basis: legitimate interest under GDPR Art. 6(1)(f) — without it, the contact form would be unusable due to bot abuse.',
            },
            billing: {
              title: 'Strictly necessary — billing',
              bullet:
                "When you open the credit-purchase modal, <strong>Lemon Squeezy</strong> takes over the checkout in an iframe / redirect under <code>lemonsqueezy.com</code>. Their checkout sets its own short-lived cookies in their domain — required for payment. They are managed under Lemon Squeezy's own cookie policy; we do not control them.",
            },
            optional: {
              title: 'Optional — analytics & error reporting',
              ga: '<strong>Google Analytics 4</strong> — third-party, set under <code>google-analytics.com</code> / <code>googletagmanager.com</code>. Typical cookies: <code>_ga</code> (2 years), <code>_ga_*</code> (2 years), <code>_gid</code> (24 hours). Purpose: aggregate page views, feature usage, traffic sources. IP anonymisation is enabled. Loaded only after you opt in above. <em>Currently not active — listed here so consent is in place when we enable it.</em>',
              sentry:
                '<strong>Sentry</strong> — third-party error monitoring. Sentry itself does not rely on cookies for tracking, but it does set short-lived <code>sessionStorage</code> keys to group related JavaScript errors into a single report. Personal data in error reports is scrubbed before transmission. Loaded only after you opt in above.',
            },
            storage: {
              title: 'Local storage & IndexedDB (not cookies, still disclosed)',
              email:
                '<code>emailForMagicLink</code> — temporary first-party value used by the email magic-link sign-in flow; cleared as soon as the link is verified.',
              consent:
                '<code>ecr.cookie.consent</code> — records the choice you made in the panel above so we do not ask again on every page.',
              firebaseDb:
                'IndexedDB <code>firebaseLocalStorageDb</code> — Firebase Auth tokens (see authentication above).',
            },
          },
          not: {
            title: 'What we do NOT use',
            bullets: {
              ads: 'No advertising, remarketing, or conversion-tracking pixels (no Meta / Facebook Pixel, no TikTok Pixel, no LinkedIn Insight Tag, no Google Ads remarketing).',
              replay:
                'No session replay (no Hotjar, FullStory, Microsoft Clarity, etc.) — we never record what you click or type.',
              abTest:
                'No A/B testing cookies — we test changes by shipping them and watching the aggregate analytics described above.',
              crossSite: 'No cross-site identifiers, no data brokers, no sale of analytics data.',
            },
            p1: 'If we ever add any of the above, we will update this page first and ask for fresh consent before loading them.',
          },
          control: {
            title: 'How to control cookies',
            p1: 'The easiest way is the panel at the top of this page — it turns analytics on or off instantly. A few other options:',
            bullets: {
              panel:
                '<strong>This page.</strong> Use the toggle at the top. Your choice is saved instantly and, if you are signed in, synced to your account.',
              browser:
                '<strong>Browser settings.</strong> Every modern browser lets you clear cookies, block third-party cookies, or set "delete on close." Doing so will sign you out of Ecranify but will not break anything else.',
              gaOptOut:
                '<strong>Google Analytics opt-out.</strong> Google offers a browser add-on at <gaOptOut>tools.google.com/dlpage/gaoptout</gaOptOut> that blocks GA across every site you visit.',
              dnt: '<strong>Do Not Track / Sec-GPC.</strong> If your browser sends <code>DNT: 1</code> or the Sec-GPC signal, we honor it as a "reject optional" automatically and let you know on your first visit.',
            },
          },
          changes: {
            title: 'Updates to this policy',
            p1: 'If we ever add a new cookie or storage technology, we will add a row to the list above and date this page at the top. Material changes get an email to active accounts. Questions about anything on this page?',
          },
        },
      },
      refund: {
        eyebrow: 'Refund Policy',
        titleLead: 'Refunds,',
        titleEm: 'by the book.',
        lede: 'How refunds work on Ecranify — who the legal seller is, what counts as digital content delivered immediately, when we will refund, when we will not, and how to file a claim. Written to satisfy Slovak Act 102/2014 Coll., Directive 2011/83/EU, and Regulation (EU) 524/2013.',
        metaUpdated: 'Last updated · May 22, 2026',
        metaReading: '8 min read',
        metaGoverned: 'Governed by Slovak law',
        tocLabel: 'On this page',
        toc: {
          seller: 'Who you are buying from',
          subject: 'What you are buying',
          consent: 'Consent & loss of withdrawal',
          whenYes: 'When we will refund',
          whenNo: 'When we will not refund',
          claim: 'How to file a claim',
          refundFlow: 'Method & timing of refunds',
          nonEu: 'Consumers outside the EU',
          arsOdr: 'Out-of-court resolution (ARS / ODR)',
          law: 'Governing law & jurisdiction',
          changes: 'Changes to this policy & contact',
        },
        sections: {
          seller: {
            title: 'Who you are buying from',
            p1: 'Two parties are involved in every credit purchase on Ecranify:',
            operatorHeading: 'The service operator',
            operatorBody:
              '<strong>Small Water s. r. o.</strong><br />Dlhá 2322/32, 926 01 Sereď, Slovakia<br />ID: 52670317 · VAT: SK2121111014<br />Registered with the District Court Trnava, section Sro, file no. 45413/T.',
            operatorRole:
              'We design, build and run the Ecranify product. We are the data controller for your account and project data — see the <privacy>Privacy Policy</privacy> for the full picture.',
            morHeading: 'The Merchant of Record',
            morBody:
              '<strong>Lemon Squeezy LLC</strong> (a Stripe company) acts as the Merchant of Record for every purchase. Lemon Squeezy is the legal seller on your receipt and is responsible for calculating, collecting and remitting VAT, sales tax and equivalent indirect taxes worldwide. The official invoice / receipt is issued by Lemon Squeezy. After each purchase you receive a confirmation email containing a link to your "My Orders" page on Lemon Squeezy, where you can enter billing details (including a VAT ID, if applicable) and download a PDF invoice at any time.',
            closing:
              'This Refund Policy applies to refunds processed by either party — in practice, both go through the same flow described below.',
          },
          subject: {
            title: 'What you are buying',
            p1: 'You are buying <strong>credits</strong>. Credits are a unit of pre-paid usage you can spend on rendering, exporting and other paid operations inside Ecranify.',
            p2: 'Credits are <strong>digital content not supplied on a tangible medium</strong> within the meaning of Act No. 102/2014 Coll. on consumer protection in distance sales (the "Slovak Distance-Sales Act") and Directive 2011/83/EU on consumer rights.',
            p3: 'Credits are delivered <strong>immediately</strong> after the payment is confirmed by Lemon Squeezy: they are credited to your Ecranify account in real time and become available for use straight away.',
          },
          consent: {
            title: 'Consent to immediate performance & loss of the right of withdrawal',
            p1: 'Because credits are digital content delivered immediately and start being performed before the 14-day statutory withdrawal period elapses, the right of withdrawal under § 7 of Act 102/2014 Coll. (Article 16(m) of Directive 2011/83/EU) <strong>does not apply</strong> — but only where the consumer has given prior express consent, together with an acknowledgement of losing that right.',
            p2: 'To make this transparent and to comply with § 4(8) of Act 102/2014, the purchase flow works as follows:',
            steps: {
              modal:
                'Before being redirected to the Lemon Squeezy checkout, you are shown a <strong>modal dialog</strong>.',
              statement:
                'The modal contains a single statement that you must actively check before you can continue to payment. The statement combines both legally required prongs in one declaration: (a) <strong>express consent</strong> to Ecranify beginning to perform the contract (i.e. crediting and making the credits usable) <strong>before the expiry of the 14-day withdrawal period</strong>, and (b) <strong>acknowledgement</strong> that by giving that consent you <strong>lose your right of withdrawal</strong> from the contract once performance begins.',
              gate: 'Without ticking that statement, the "Continue to payment" button stays disabled — there is no way to reach Lemon Squeezy checkout without giving this consent.',
              record:
                'The text of the statement, its version identifier and the resulting order ID are stored together with your purchase record — on the same database row that grants your credits — so that we can reproduce in a dispute exactly what you agreed to. A copy is also included in the receipt email Lemon Squeezy sends you.',
            },
            fallback:
              'Where the consumer has <strong>not</strong> given the consent above (e.g. a future flow change, a B2B purchase, or a technical error), the 14-day right of withdrawal applies in full.',
          },
          whenYes: {
            title: 'When we will refund',
            p1: 'We will refund the price of credits in the following situations, regardless of whether you have given the consent described above:',
            bullets: {
              untouched:
                '<strong>Untouched pack within 14 days</strong> — even though the strict statutory withdrawal right does not apply (see § 3 above), we voluntarily refund any credit pack that you have not yet used (no render has drawn from it) when you ask within 14 days of the purchase date. This is our policy promise on top of the law — see the "Refundable" badge in your <account>account history</account>.',
              tech: '<strong>Our technical fault</strong> — credits were not credited after a successful payment; an export, render or other paid operation failed because of a defect on our side; the credits behave differently from what is described in the product.',
              duplicate:
                '<strong>Duplicate or mistaken payment</strong> — the same order was charged twice, or a payment was clearly executed by mistake (e.g. several identical orders within seconds).',
              unauthorised:
                '<strong>Unauthorised payment</strong> — the payment was made without your authorisation (lost card, account take-over, etc.). Please also notify your bank.',
              defect:
                '<strong>Other defects of performance</strong> — any situation in which we have failed to deliver what we promised under our <terms>Terms of Use</terms>.',
            },
          },
          whenNo: {
            title: 'When we will not refund',
            p1: 'We will not refund credits in the following situations:',
            bullets: {
              used: '<strong>Pack already used</strong> — as soon as any credit from a pack has been spent on a successful render, export, or other paid operation, the pack as a whole becomes non-refundable. The performance has been delivered.',
              changeOfMind:
                '<strong>Change of mind after credits were used</strong> — the 14-day "untouched pack" refund described above is voluntary on top of the statutory rules. Once you have started using credits from a pack, you cannot fall back on the statutory right of withdrawal either — § 7 of Act 102/2014 / Art. 16(m) of Directive 2011/83/EU specifically removes it for digital content delivered immediately when you have given the consent described in § 3.',
              expired:
                '<strong>Untouched pack older than 14 days</strong> — past the 14-day window the voluntary refund offer no longer applies. (If credits are otherwise unusable due to a defect on our side, the rules in § 4 above apply regardless of age.)',
              dislike:
                '<strong>Dissatisfaction with a successfully produced output</strong> — subjective dislike of the visual result of an otherwise correctly delivered render is not a defect of performance.',
              breach:
                '<strong>Account suspended or terminated for breach</strong> — credits forfeited as a result of a breach of our <terms>Terms of Use</terms> (fraud, chargeback abuse, illegal content, etc.) are non-refundable.',
            },
          },
          claim: {
            title: 'How to file a claim',
            p1: 'To file a claim, write to us through the <contact>contact form</contact> and include:',
            bullets: {
              orderId: 'your <strong>order ID</strong> (from the Lemon Squeezy receipt email);',
              email: 'the email address associated with your Ecranify account;',
              issue: 'a description of the issue (what you bought, what went wrong, when);',
              evidence: 'any screenshots or error messages that help us reproduce the problem.',
            },
            ack: 'We will send you a written <strong>acknowledgement of receipt</strong> without undue delay (typically within 24 hours).',
            timing:
              'Your claim will be handled and you will be informed of the outcome <strong>no later than 30 days</strong> from the day you filed it, in accordance with § 18(4) of Act No. 250/2007 Coll. on consumer protection. In most cases we resolve claims within a few business days.',
          },
          refundFlow: {
            title: 'Method and timing of refunds',
            p1: 'If a claim is upheld, the refund is issued <strong>using the same payment method</strong> you used for the original purchase, unless you expressly agree to a different method that does not put any additional cost on you.',
            p2: 'We will return the funds <strong>no later than 14 days</strong> from the day on which we acknowledged the refund claim, in line with § 9 of Act No. 102/2014 Coll. (or the corresponding Directive 2011/83/EU rule). The time it takes the money to appear on your statement after that depends on your bank or payment provider.',
            p3: 'At the same time as the refund is issued, the <strong>corresponding number of credits is deducted</strong> from your Ecranify account so that the balance reflects only credits that remain paid for. If your balance is lower than the refunded amount at that moment, the resulting negative balance is settled against your next purchase.',
            p4: 'The refund is for the price you actually paid. We do not deduct payment-processing fees, currency-conversion fees, or any "restocking" charge.',
          },
          nonEu: {
            title: 'Consumers outside the EU',
            p1: 'Although the statutory framework cited above applies primarily to EU consumers, we apply <strong>the same refund standard worldwide</strong> for the sake of fairness and simplicity. Wherever you live, the rules in sections 4–7 of this policy apply to you.',
            p2: 'Local mandatory consumer rights in your country of habitual residence are not affected by this policy.',
          },
          arsOdr: {
            title: 'Out-of-court dispute resolution (ARS) & ODR',
            p1: 'If you are not satisfied with the way we have handled your claim, you have the right to turn to an Alternative Dispute Resolution body. The competent authority in Slovakia is:',
            soiBody:
              '<strong>Slovenská obchodná inšpekcia</strong> (Slovak Trade Inspection)<br />Ústredný inšpektorát SOI, P. O. BOX 29, Bajkalská 21/A, 827 99 Bratislava<br /><soi>www.soi.sk</soi>',
            odrBody:
              "EU consumers can also use the European Commission's <strong>Online Dispute Resolution platform</strong>, provided under Regulation (EU) No 524/2013, at <odr>ec.europa.eu/consumers/odr</odr>.",
            closing:
              'Using ARS or ODR is voluntary; before you do, we strongly encourage you to <contact>contact us</contact> first — most issues are resolved within a few working days.',
          },
          law: {
            title: 'Governing law & jurisdiction',
            p1: 'This Refund Policy and the contract for the sale of credits are governed by the law of the <strong>Slovak Republic</strong>, excluding its conflict-of-law rules.',
            p2: 'If you are a <strong>consumer habitually resident in the European Union</strong>, this choice of law does not deprive you of the protection of the mandatory provisions of the law of the country where you have your habitual residence (Article 6 of Regulation (EC) No 593/2008 — "Rome I").',
            p3: 'Disputes are subject to the jurisdiction of the courts of the Slovak Republic. EU consumers may, however, bring proceedings against us in the courts of the Member State in which they are domiciled, and we may sue an EU consumer only in the courts of the Member State of their domicile, in accordance with Articles 17–18 of Regulation (EU) No 1215/2012 ("Brussels Ia").',
          },
          changes: {
            title: 'Changes to this policy & contact',
            p1: 'We may update this Refund Policy from time to time (e.g. to reflect changes in the law, in the purchase flow, or in our service). The version that applies to a given purchase is the one in force at the moment the order was placed.',
            p2: 'Material changes will be announced to active accounts by email at least 30 days before they take effect. Minor wording changes are dated at the top of the page.',
            p3: 'For any questions about this policy or a specific refund, please <contact>contact us</contact> — we usually reply the same day.',
          },
        },
      },
      imprint: {
        eyebrow: 'Imprint · Impressum · Legal Notice',
        titleLead: 'Who runs',
        titleEm: 'Ecranify.',
        lede: 'The company behind ecranify.app, who acts for it, and how to reach us. Provided per § 4 of Act 22/2004 Coll. on electronic commerce and equivalent EU disclosure obligations.',
        metaUpdated: 'Last updated · May 22, 2026',
        metaGoverned: 'Governed by Slovak law',
        tocLabel: 'On this page',
        toc: {
          company: 'Company',
          reps: 'Managing Directors',
          contact: 'Contact',
          supervision: 'Supervisory authority',
          odr: 'Online dispute resolution (EU)',
        },
        sections: {
          company: {
            title: 'Company',
            addressBody:
              '<strong>Small Water s. r. o.</strong><br /><em>Dlhá 2322/32, 926 01 Sereď</em>, Slovak Republic<br />Company ID: <em>52670317</em> · Tax ID: <em>2121111014</em> · VAT ID: <em>SK2121111014</em>',
            registration:
              'Registered in the Commercial Register of the District Court <em>Trnava</em>, Section: Sro, File no. <em>45413/T</em>.',
          },
          reps: {
            title: 'Managing Directors',
            list: '<em>Vladislav Vodička</em>',
            authority: 'Each Managing Director is authorised to act independently on behalf of the company.',
          },
          contact: {
            title: 'Contact',
            formLine: 'Reach us through the <contact>contact form</contact>.',
            emailLine: 'Email: <em>ecranify@ecranify.com</em>',
            note: 'The contact form is the fastest way to reach us — we usually reply the same day.',
          },
          supervision: {
            title: 'Supervisory authority',
            trade: '<strong>Trade activities:</strong> District Office Galanta, Trade Licensing Department.',
            dataProtection:
              '<strong>Personal-data supervision:</strong> Úrad na ochranu osobných údajov Slovenskej republiky — <dpa>dataprotection.gov.sk</dpa>.',
          },
          odr: {
            title: 'Online dispute resolution (EU)',
            p1: "EU consumers can use the European Commission's ODR platform at <odr>ec.europa.eu/consumers/odr</odr>. The competent Slovak ADR body is the Slovak Trade Inspection (<soi>soi.sk</soi>).",
            p2: 'See the <refund>Refund Policy</refund> for the full procedure for filing a claim and reaching an out-of-court resolution.',
          },
        },
      },
      cookieBanner: {
        aria: 'Cookie consent',
        body: 'We use strictly necessary cookies to keep you signed in. We would also like to set analytics cookies (Google Analytics, Sentry) so we can understand usage and fix bugs — only if you opt in.',
        dntBody:
          'We detected Do Not Track in your browser and disabled analytics for you. You can change this on the <policy>cookie policy</policy> page.',
        acceptAll: 'Accept all',
        rejectAll: 'Reject all',
        cookiePolicy: 'Cookie policy',
        ok: 'OK',
      },
      unsubscribe: {
        title: 'Unsubscribe from product emails',
        lede: "Click below to stop receiving product update emails from Ecranify. Once you unsubscribe we won't add you back without your explicit opt-in.",
        confirmBtn: 'Confirm unsubscribe',
        pending: 'Working …',
        successTitle: "You're unsubscribed.",
        successBody:
          "We won't email <strong>{{email}}</strong> again. If you change your mind later, just write to us.",
        successBodyNoEmail: "You're off the list. We won't email you again.",
        invalidTitle: 'This link is no longer valid.',
        invalidBody:
          'It may have expired or already been used. <contact>Contact us</contact> and we will remove you manually.',
        errorTitle: 'Something went wrong.',
        errorBody:
          "We couldn't process your unsubscribe right now. Please try again in a few minutes, or <contact>contact us</contact>.",
        backHome: 'Back to home',
      },
      footer: {
        taglinePart1: 'Studio-quality App Store screenshots,',
        taglinePart2: 'rendered live in your browser.',
        productLabel: 'Product',
        companyLabel: 'Company',
        legalLabel: 'Legal',
        guidesLabel: 'Guides',
        guideScreenshotSizes: 'Screenshot sizes',
        guideFeatureGraphic: 'Play feature graphic',
        guideHowToMake: 'How to make screenshots',
        guideBestPractices: 'Screenshot best practices',
        guideFoldableIphone: 'iPhone 18 & foldable iPhone',
        moreGuides: 'More guides →',
        home: 'Home',
        features: 'Features',
        projects: 'Projects',
        pricing: 'Pricing',
        newProject: 'New project',
        about: 'About us',
        contact: 'Contact',
        faq: 'FAQ / Help',
        terms: 'Terms of Use',
        privacy: 'Privacy Policy',
        cookies: 'Cookie Policy',
        refund: 'Refund Policy',
        imprint: 'Legal Notice / Impressum',
        baseShortTerms: 'Terms',
        baseShortPrivacy: 'Privacy',
        baseShortCookies: 'Cookies',
        baseShortImprint: 'Imprint',
        copyright: '© {{year}} Small Water s. r. o.',
      },
      toast: {
        dismiss: 'Dismiss',
      },
      a11y: {
        windowMinimize: 'Minimize',
        windowMaximize: 'Maximize',
        windowClose: 'Close',
        undo: 'Undo',
        redo: 'Redo',
        pagination: 'Pagination',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        spritePreview: 'Sprite preview',
        screenPreview: 'Screen preview',
        backgroundPreview: 'Background preview',
        footer: 'Footer',
        loading: 'Loading…',
      },
    },
  },
} as const

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})
